/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as React from "react";
import * as moment from "moment";
import { connect } from "react-redux";
import { createValidator } from "not-valid";
import {
    Container,
    Segment,
    Loader,
    List,
    Button,
    Confirm,
    Modal,
    Form,
    Label,
    Tab,
    TabProps,
    Divider,
} from "semantic-ui-react";

import { uniq, flatten, values } from "lodash";

import { AccordionQuestionnaireContainer } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireContainer";
import { AccordionQuestionnaireSection } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireSection";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { RadioButton, RadioButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/RadioButtonQuestion";
import { NumberQuestion } from "@teamprevent/common/questionnaires/components/questions/NumberQuestion";
import { MultiButtonQuestion, YesOption, NoOption } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { OldDateQuestion } from "@teamprevent/common/questionnaires/components/questions/OldDateQuestion";
import {
    openSection,
    updateQuestion,
    submitInvalidQuestionnaire,
    clearQuestionnaire,
    removeQuestion
} from "@teamprevent/common/questionnaires/actions";
import { AnsweredQuestion, AnsweredQuestionWithId, QuestionnaireTypes } from "@teamprevent/common/questionnaires/model";
import { CheckboxQuestion } from "@teamprevent/common/questionnaires/components/questions/CheckboxQuestion";
import { navigateToParentRoute } from "@teamprevent/common/routing/actions";
import { ConsultationDetails } from "@teamprevent/common/consultations/models";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { TextSnippetSelector } from "@teamprevent/common/components/TextSnippetSelector";
import { QuestionAnswer } from "@teamprevent/common/questionnaires/model";
import { ViewClinicalHistoryButton } from "@teamprevent/common/referralReport/components/ViewClinicalHistoryButton";
import { PreviewReferralReportButton } from "@teamprevent/common/referralReport/components/PreviewReferralReportButton";
import { getQuestionConfig, CustomQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import * as iaptQuestionIds from "@teamprevent/common/questionnaires/questionnaireConfig/referral/IAPT/questionIds";
import { masterConfig as iaptMasterConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/referral/IAPT/masterConfig";
import * as iaptPhq9QuestionIds from "@teamprevent/common/questionnaires/questionnaireConfig/referral/IAPT/phq9QuestionIds";
import { masterConfig as iaptPhq9MasterConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/referral/IAPT/phq9MasterConfig";
import * as iaptGad7QuestionIds from "@teamprevent/common/questionnaires/questionnaireConfig/referral/IAPT/gad7QuestionIds";
import { masterConfig as iaptGad7MasterConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/referral/IAPT/gad7MasterConfig";
import * as iaptWsasQuestionIds from "@teamprevent/common/questionnaires/questionnaireConfig/referral/IAPT/wsasQuestionIds";
import { masterConfig as iaptWsasMasterConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/referral/IAPT/wsasMasterConfig";
import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { Appointment } from "@teamprevent/common/calendar";
import { TimeQuestion } from "@teamprevent/common/questionnaires/components/questions/TimeQuestion";

import { ApplicationState } from "../../applicationState";
import { CurrentUser } from "../../auth";
import { PartialOhCaseDetailModel, OhCaseDetailModel, OhCaseListModel } from "../../crud/ohCase";
import { AdminUser, getUserDisplayName } from "../../crud/adminUser/model";

import { loadQuestionnaire, submitDidNotAttend, loadConsultationDetails } from "../actions";
import { routeIdSelector as ohCaseIdSelector } from "../../crud/ohCase/selectors";
import { EmployeeRecord, EmployeeRecordState } from "../../crud/employeeRecord";
import { loadEmployeeRecordDetail } from "../../crud/employeeRecord/actions";
import { ActionableTasksState } from "../../actionableTasks";
import { loadAdminUsers } from "../../crud/adminUser";
import { adminUsersSelector } from "../../crud/adminUser/selectors";
import {
    currentWorkStatusOptions,
    FunctionalAssessmentTestType,
    functionalAssessmentTestOptions,
    injuredQuestionOptions,
    dropdownFunctionalAssessmentTestOptions,
    smokingStatusQuestionOptions,
    psychologicalAssessmentOutcomeQuestionOptions,
    PsychologicalAssessmentOutcome,
    impactOnAbilityToPerformJobQuestionOptions,
    adherenceToHomeExerciseAndAdvicePlanQuestionOptions,
    ohaMedicalClassificationOptions,
    medicalClassificationSubCategoryOptions,
    workRelatedHealthIssueQuestionOptions,
    ClinicalNotesVersion,
    ohpTaskTypes,
    diabeticOptions,
    iaptQuestionnaireAnswers,
    iaptQuestionnaireAnswerOptions,
    iaptQuestionnaireWsasAnswerOptions,
    symptomsOptions,
    originTypeOptions,
    OriginTypes,
    accidentOutcomeOptions,
    typeOfInjuryOptions,
} from "../models";

import "../styles/referral-clinical-notes-sections.scss";

import { PhysioAssessmentFormVersionButton } from "../../referrals/components/PhysioAssessmentFormVersionButton";
import { PhysioAssessmentFormVersion } from "../../referrals/models";
import { TasksApi } from "../../tasks/tasksApi";
import { calendarApi } from "../../calendar/calendarApi";
import { customerSelector } from "../../crud/customer/selectors";
import { Customer } from "../../crud/customer";

import { OutcomeAndOnwardManagementOfTheCaseSection } from "./OutcomeAndOnwardManagementOfTheCaseSectionV2_V3";
import { ReferralIntroductionAndDataPrivacySection } from "./ReferralIntroductionAndDataPrivacySection";
import { DidNotAttendButton } from "./DidNotAttendButton";

import { replace } from "redux-little-router";

export const questionnaireKey = "clinicalNotes";

export interface ClinicalNotesQuestionsProps {
    readonly?: boolean;
    questions?: AnsweredQuestionWithId[];
    employeeRecord?: EmployeeRecord;
    ohCase?: OhCaseDetailModel;
}

export type ClinicalNotesProps = ClinicalNotesQuestionsProps & { questionnaireKey?: string; index?: number };

interface ClinicalNotesStateProps {
    customerId: string;
    customer: Customer;
    taskId: string;
    task: TaskModel;
    ohCaseId: string;
    currentUser: CurrentUser;
    ohCase: PartialOhCaseDetailModel;
    employeeRecord: EmployeeRecord;
    questions: AnsweredQuestionWithId[];
    readonly: boolean;
    isLoading: boolean;
    adminUsers: AdminUser[];
    clinicansQualification: string;
    consultationDetails: ConsultationDetails;
    isOhp: boolean;
    eTag: string;
}

export interface ClinicalNotesDispatchProps {
    navigateToOldClinicalNotes: (customerId: string, employeeRecordId: string, ohCaseId: string, taskId: string, version: number) => void;
    loadEmployee: (employeeRecordId: string, customerId: string) => void;
    startNotes: () => void;
    updateAnswer: (payload: { sectionId: string; id: string; question: AnsweredQuestion }) => void;
    // Should make AbortController mandatory as soon as practical
    loadQuestionnaire: (abortController: AbortController | undefined, ohCaseId: string, taskId: string, customerId: string) => Promise<void>;
    submitDidNotAttend: (ohCaseId: string, taskId: string, comment: string | undefined) => void;
    onCompletion: () => void;
    submitInvalidQuestionnaire: () => void;
    loadAdminUsers: () => void;
    loadConsultationDetails: (ohCaseId: string, taskId: string) => Promise<void>;
    clearQuestionnaire: () => void;
    removeAnswer: (payload: { sectionId: string; id: string }) => void;
}

interface ClinicalNotesOwnProps {
    intro?: string;
    submitQuestionnaire: (ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[]) => void;
    saveQuestionnaire: (ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[], eTag: string) => Promise<any>;
}

interface State {
    simplifiedNotesAndReportConfirmationOpen: boolean;
    simplifiedNotesAndReportConfirmationValue?: string;
    redirecting: boolean;
    redirectChecked: boolean;
    submitted: boolean;
    dnaModalOpen: boolean;
    dnaComment: string | undefined;
    iaptQuestionnaireModalOpen: boolean;
    iaptModalActiveIndex: number;
    iaptQuestionnaireModalSubmitted: boolean;
    psychologicalWellbeingPHQ9Score: number;
    psychologicalWellbeingGAD7Score: number;
    psychologicalWellbeingWSASScore: number;
    openConfirmation: boolean;
    appointment: Appointment | undefined;
    loadedAppointment: boolean;
}

const isDateInTheFuture = (value: moment.Moment) => {
    return value?.isSameOrAfter(moment().startOf("day"));
};

export const isDateInThePast = (value: moment.Moment) => {
    return value?.isSameOrBefore(moment().startOf("day"));
};

class ReferralClinicalNotesSectionsUnconnected extends React.Component<ClinicalNotesDispatchProps & ClinicalNotesStateProps & ClinicalNotesOwnProps, State> {
    public readonly completedOnBehalfOfSectionId = "CompletedOnBehalfOf";
    public readonly completedOnBehalfOfQuestion = { questionText: "Completed on behalf of", id: "CompletedOnBehalfOf" };
    public readonly completedOnBehalfOfIdQuestion = { questionText: "", id: "CompletedOnBehalfOfId" };
    public readonly completedOnBehalfOfNameQuestion = { questionText: "", id: "CompletedOnBehalfOfName" };
    public readonly completedOnBehalfOfQualificationQuestion = { questionText: "", id: "CompletedOnBehalfOfQualification" };

    public readonly socialHistorySectionId = "SocialHistory";
    public readonly consultationDetailsSectionId = "ConsultationDetails";
    public readonly startTimeQuestion = { questionText: "The start time of the consultation", id: "StartTime" };
    public readonly finishTimeQuestion = { questionText: "The finish time of the consultation", id: "FinishTime" };
    public readonly clinicianIdQuestion = { questionText: "", id: "CliniciansId" };
    public readonly clinicianNameQuestion = { questionText: "Clinician's name", id: "CliniciansName" };
    public readonly clinicianQualificationQuestion = { questionText: "Clinician's qualification", id: "CliniciansQualification" };
    public readonly physioAssessmentFormVersionQuestion = { questionText: "PhysioAssessmentFormVersion", id: "PhysioAssessmentFormVersion" };
    public readonly iaptQuestionnaireSectionId = "IaptQuestionnaire";

    public readonly clinicalNotesCurrentVersionQuestionId = "ClinicalNotesCurrentVersion";
    public state: State = {
        redirecting: false,
        redirectChecked: false,
        submitted: false,
        simplifiedNotesAndReportConfirmationOpen: false,
        dnaModalOpen: false,
        dnaComment: undefined,
        iaptQuestionnaireModalOpen: false,
        iaptModalActiveIndex: 0,
        iaptQuestionnaireModalSubmitted: false,
        psychologicalWellbeingPHQ9Score: 0,
        psychologicalWellbeingGAD7Score: 0,
        psychologicalWellbeingWSASScore: 0,
        openConfirmation: false,
        appointment: undefined,
        loadedAppointment: false
    };

    private saveQuestionnaire(questions: AnsweredQuestionWithId[], eTag: string) {
        return this.props.saveQuestionnaire(this.props.ohCaseId, this.props.taskId, this.props.customerId, questions, eTag);
    }

    constructor(props: ClinicalNotesDispatchProps & ClinicalNotesStateProps & ClinicalNotesOwnProps) {
        super(props);

        props.clearQuestionnaire();

        this.saveQuestionnaire = this.saveQuestionnaire.bind(this);
        this.submitQuestionnaire = this.submitQuestionnaire.bind(this);
        this.loadQuestionnaire = this.loadQuestionnaire.bind(this);
        this.updateCompletedOnBehalfOfAnswers = this.updateCompletedOnBehalfOfAnswers.bind(this);
        if (this.props.ohCase?.employeeRecordId) {
            this.props.loadEmployee(this.props.ohCase.employeeRecordId, this.props.customerId);
        }
        this.onSimplifiedNotesAndReportInvokerChange = this.onSimplifiedNotesAndReportInvokerChange.bind(this);
        this.confirmSimplifiedNotesAndReportChange = this.confirmSimplifiedNotesAndReportChange.bind(this);
        this.cancelSimplifiedNotesAndReportChange = this.cancelSimplifiedNotesAndReportChange.bind(this);
        this.onCarryOutPsychologicalAssessmentChange = this.onCarryOutPsychologicalAssessmentChange.bind(this);
        this.onPsychologicalWellbeingScoreChange = this.onPsychologicalWellbeingScoreChange.bind(this);
        this.getChosenImpactsOnAbilityToPerformJob = this.getChosenImpactsOnAbilityToPerformJob.bind(this);
        this.getChosenFunctionalAssessmentTests = this.getChosenFunctionalAssessmentTests.bind(this);
        this.updateSnippets = this.updateSnippets.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.onConsultationFormChange = this.onConsultationFormChange.bind(this);
        this.onTabChange = this.onTabChange.bind(this);
        this.warningTextHeader = this.warningTextHeader.bind(this);
        this.getQuestionClassName = this.getQuestionClassName.bind(this);
    }

    public componentDidMount() {
        if (!this.props.readonly) {
            this.props.loadAdminUsers();
        }

        if (this.props.taskId && this.props.ohCase?.id) {
            this.props.loadConsultationDetails(this.props.ohCase.id, this.props.taskId);
        }
    }

    public async loadQuestionnaire(abortController?: AbortController) {
        await this.props.loadQuestionnaire(abortController, this.props.ohCaseId, this.props.taskId, this.props.customerId);

        if (!this.props.readonly) {
            this.props.updateAnswer({
                sectionId: this.consultationDetailsSectionId,
                id: this.startTimeQuestion.id,
                question: { question: this.startTimeQuestion.questionText, answer: moment.utc().format("YYYY-MM-DD HH:mm:ss"), isValid: true }
            });
        }
        if (this.props.currentUser) {
            this.updateCurrentUserAnswers();
        }
    }

    public componentDidUpdate?(prevProps: Readonly<ClinicalNotesStateProps>) {
        // Load admin users only when clinical notes form has been refreshed, and task is loaded after first render
        if (prevProps.readonly && !this.props.readonly && (!this.props.adminUsers || this.props.adminUsers.length === 0)) {
            this.props.loadAdminUsers();
        }

        if (!this.state.redirectChecked && this.props.ohCase && this.props.currentUser
            && this.props.questions.some(q => q.id === this.clinicalNotesCurrentVersionQuestionId)) {
            const currentClinicalNotesVersion = getAnswerToQuestionWithId(this.props.questions, this.clinicalNotesCurrentVersionQuestionId) as number;

            // Route V1 clinical notes to old page and send V2 and V3 to new page
            if (currentClinicalNotesVersion === ClinicalNotesVersion.V1) {
                this.setState({ redirecting: true, redirectChecked: true }, () => {
                    this.props.navigateToOldClinicalNotes(
                        this.props.customerId,
                        this.props.ohCase.employeeRecordId!,
                        this.props.ohCase.id,
                        this.props.taskId,
                        currentClinicalNotesVersion
                    );
                });
            } else {
                this.setState({ redirecting: false, redirectChecked: true });
            }
        }

        if (this.props.currentUser &&
            (this.props.currentUser !== prevProps.currentUser || this.props.clinicansQualification !== prevProps.clinicansQualification)) {
            this.updateCurrentUserAnswers();
        }

        if (this.props.ohCase && this.props.ohCase !== prevProps.ohCase) {
            this.props.loadEmployee(this.props.ohCase.employeeRecordId!, this.props.customerId);
        }

        if (this.props.taskId && this.props.taskId !== prevProps.taskId &&
            this.props.ohCase?.id && this.props.ohCase.id !== prevProps.ohCase?.id) {
            this.props.loadConsultationDetails(this.props.ohCase.id, this.props.taskId);
        }

        if (this.props.questions.find(q => q.id === this.completedOnBehalfOfQuestion.id)?.answer
            !== prevProps.questions.find(q => q.id === this.completedOnBehalfOfQuestion.id)?.answer) {
            this.updateCompletedOnBehalfOfAnswers();
        }

        if (this.props.task?.appointmentId && !this.state.appointment && !this.state.loadedAppointment) {
            this.setState({
                loadedAppointment: true
            });

            calendarApi.get(this.props.task.appointmentId).then(response => { // eslint-disable-line promise/always-return
                this.setState({
                    appointment: response
                });
            });
        }
    }

    public componentWillUnmount() {
        this.props.clearQuestionnaire();
    }

    public updateCurrentUserAnswers() {
        if (!this.props.readonly) {
            this.props.updateAnswer({
                sectionId: this.consultationDetailsSectionId,
                id: this.clinicianIdQuestion.id,
                question: { question: this.clinicianIdQuestion.questionText, answer: this.props.currentUser.id, isValid: true }
            });
            this.props.updateAnswer({
                sectionId: this.consultationDetailsSectionId,
                id: this.clinicianNameQuestion.id,
                question: { question: this.clinicianNameQuestion.questionText, answer: this.props.currentUser.name, isValid: true }
            });
            this.props.updateAnswer({
                sectionId: this.consultationDetailsSectionId,
                id: this.clinicianQualificationQuestion.id,
                question: { question: this.clinicianQualificationQuestion.questionText, answer: this.props.clinicansQualification, isValid: true }
            });
        }
    }

    public updateCompletedOnBehalfOfAnswers() {
        if (!this.props.readonly) {
            const adminUserId = getAnswerToQuestionWithId(this.props.questions, this.completedOnBehalfOfQuestion.id);
            const adminUser = this.props.adminUsers.find(u => u.id === adminUserId);
            const completedOnBehalfOfId = adminUserId ?? "";
            const completedOnBehalfOfFullName = adminUser ? getUserDisplayName(adminUser, true, true) : "";
            const completedOnBehalfOfQualification = adminUser?.qualification ?? "";
            this.props.updateAnswer({
                sectionId: this.consultationDetailsSectionId,
                id: this.completedOnBehalfOfIdQuestion.id,
                question: { question: this.completedOnBehalfOfIdQuestion.questionText, answer: completedOnBehalfOfId, isValid: true }
            });
            this.props.updateAnswer({
                sectionId: this.consultationDetailsSectionId,
                id: this.completedOnBehalfOfNameQuestion.id,
                question: { question: this.completedOnBehalfOfNameQuestion.questionText, answer: completedOnBehalfOfFullName, isValid: true }
            });
            this.props.updateAnswer({
                sectionId: this.consultationDetailsSectionId,
                id: this.completedOnBehalfOfQualificationQuestion.id,
                question: { question: this.completedOnBehalfOfQualificationQuestion.questionText, answer: completedOnBehalfOfQualification, isValid: true }
            });
        }
    }

    public async submitQuestionnaire(questions: AnsweredQuestionWithId[]): Promise<boolean> {
        const carryOutPsychologicalAssessmentQuestion = questions.find(q => q.id === "CarryOutPsychologicalAssessment");

        if (carryOutPsychologicalAssessmentQuestion?.answer !== YesOption) {
            // If IAPT modal was opened and then PsychologicalAssessment question was selected as "No",
            // the IAPT questions that might have been added, should be removed and not saved as part of the questionnaire.
            questions = questions.filter(q =>
                q.id !== iaptQuestionIds.IaptCarryOutIaptAssessment &&
                !iaptMasterConfig.some(m => m.id === q.id) &&
                !iaptPhq9MasterConfig.some(m => m.id === q.id) &&
                !iaptGad7MasterConfig.some(m => m.id === q.id) &&
                !iaptWsasMasterConfig.some(m => m.id === q.id));
        }

        if (!questions.every(question => question.isValid)) {
            this.props.submitInvalidQuestionnaire();
            return false;
        }

        const finishTimeAnswerIndex = questions.findIndex(q => q.sectionId === this.consultationDetailsSectionId && q.id === this.finishTimeQuestion.id);
        const finishTimeAnswer = {
            id: this.finishTimeQuestion.id,
            question: this.finishTimeQuestion.questionText,
            answer: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            isValid: true,
            sectionId: this.consultationDetailsSectionId
        };
        if (finishTimeAnswerIndex > -1) {
            questions[finishTimeAnswerIndex] = finishTimeAnswer;
        } else {
            questions.push(finishTimeAnswer);
        }

        this.setState({ submitted: true });
        await this.props.submitQuestionnaire(this.props.ohCaseId, this.props.taskId, this.props.customerId, questions);

        return true;
    }

    public onSimplifiedNotesAndReportInvokerChange(newAnswer: QuestionAnswer) {
        this.setState({ simplifiedNotesAndReportConfirmationOpen: true, simplifiedNotesAndReportConfirmationValue: newAnswer as string });
    }

    public confirmSimplifiedNotesAndReportChange() {
        this.setState({ simplifiedNotesAndReportConfirmationOpen: false }, () => {
            this.props.updateAnswer({
                sectionId: this.completedOnBehalfOfSectionId,
                id: "SimplifiedNotesAndReport",
                question: {
                    question: "By doing this action, you will be removing previously written content on this form. Are you sure you want to continue?",
                    answer: this.state.simplifiedNotesAndReportConfirmationValue,
                    isValid: true
                }
            });
        });
    }

    public cancelSimplifiedNotesAndReportChange() {
        this.setState({ simplifiedNotesAndReportConfirmationOpen: false }, () => {
            this.props.updateAnswer({
                sectionId: this.completedOnBehalfOfSectionId,
                id: "SimplifiedNotesAndReportInvoker",
                question: {
                    question: "By doing this action, you will be removing previously written content on this form. Are you sure you want to continue?",
                    answer: this.state.simplifiedNotesAndReportConfirmationValue === "UseSimplifiedNotesAndReport" ? "" : "UseSimplifiedNotesAndReport",
                    isValid: true
                }
            });
        });
    }

    private onConsultationFormChange(formVersion: PhysioAssessmentFormVersion) {
        this.props.updateAnswer({
            sectionId: this.completedOnBehalfOfSectionId,
            id: this.physioAssessmentFormVersionQuestion.id,
            question: {
                question: this.physioAssessmentFormVersionQuestion.questionText,
                answer: formVersion,
                isValid: true
            }
        });
    }

    public getChosenFunctionalAssessmentTests(): string[] {
        const functionalAssessmentTestsAnswer = getAnswerToQuestionWithId(this.props.questions, "FunctionalCapacityFunctionalAssessmentTests");
        if (!functionalAssessmentTestsAnswer) {
            return [];
        }

        if (Array.isArray(functionalAssessmentTestsAnswer)) {
            return functionalAssessmentTestsAnswer as string[];
        }

        if (typeof functionalAssessmentTestsAnswer === "string") {
            return [functionalAssessmentTestsAnswer];
        }

        return [];
    }

    public onCarryOutPsychologicalAssessmentChange(answer: QuestionAnswer) {
        if (answer === YesOption) {
            this.props.updateAnswer({
                sectionId: "PsychologicalAssessment",
                id: "PsychologicalWellbeingPHQ9Outcome",
                question: { question: "PHQ9 Outcome", answer: PsychologicalAssessmentOutcome.NotScored, isValid: true }
            });
            this.props.updateAnswer({
                sectionId: "PsychologicalAssessment",
                id: "PsychologicalWellbeingGAD7Outcome",
                question: { question: "GAD7 Outcome", answer: PsychologicalAssessmentOutcome.NotScored, isValid: true }
            });
            this.props.updateAnswer({
                sectionId: "PsychologicalAssessment",
                id: "PsychologicalWellbeingWSASOutcome",
                question: { question: "WSAS Outcome", answer: PsychologicalAssessmentOutcome.NotScored, isValid: true }
            });
        } else {
            this.props.removeAnswer({
                sectionId: "PsychologicalAssessment",
                id: iaptQuestionIds.IaptCarryOutIaptAssessment
            });
        }
    }

    public onPsychologicalWellbeingScoreChange(outcomeId: string, outcomeQuestion: string, answer: QuestionAnswer) {
        let newAnsweredQuestion: AnsweredQuestion | null = null;

        if ((answer as string).length === 0) {
            newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.NotScored, isValid: true };
        }
        else {
            const numberAnswer = +(answer ?? 0);
            switch (outcomeId) {
                case "PsychologicalWellbeingPHQ9Outcome":
                    if (numberAnswer < 5) {
                        newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.NoDepression, isValid: true };
                    } else if (numberAnswer < 10) {
                        newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.MildDepression, isValid: true };
                    } else if (numberAnswer < 15) {
                        newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.ModerateDepression, isValid: true };
                    } else if (numberAnswer < 20) {
                        newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.ModeratelySevereDepression, isValid: true };
                    } else {
                        newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.SevereDepression, isValid: true };
                    }
                    break;
                case "PsychologicalWellbeingGAD7Outcome":
                    if (numberAnswer < 5) {
                        newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.NoAnxiety, isValid: true };
                    } else if (numberAnswer < 10) {
                        newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.MildAnxiety, isValid: true };
                    } else if (numberAnswer < 15) {
                        newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.ModerateAnxiety, isValid: true };
                    } else {
                        newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.SevereAnxiety, isValid: true };
                    }
                    break;
                case "PsychologicalWellbeingWSASOutcome":
                    if (numberAnswer <= 10) {
                        newAnsweredQuestion = { question: outcomeQuestion, answer: PsychologicalAssessmentOutcome.NoFunctionalImpairment, isValid: true };
                    } else if (numberAnswer <= 20) {
                        newAnsweredQuestion = {
                            question: outcomeQuestion,
                            answer: PsychologicalAssessmentOutcome.MildToModerateFunctionalImpairment,
                            isValid: true
                        };
                    } else {
                        newAnsweredQuestion = {
                            question: outcomeQuestion,
                            answer: PsychologicalAssessmentOutcome.ModerateOrSevereFunctionalImpairment,
                            isValid: true
                        };
                    }
                    break;
                default:
                    break;
            }
        }

        if (newAnsweredQuestion) {
            this.props.updateAnswer({
                sectionId: "PsychologicalAssessment",
                id: outcomeId,
                question: newAnsweredQuestion
            });
        }
    }

    public getChosenImpactsOnAbilityToPerformJob(): string[] {
        const impactsOnAbilityToPerformJobAnswer = getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingImpactOnAbilityToPerformJob");
        if (!impactsOnAbilityToPerformJobAnswer) {
            return [];
        }

        if (Array.isArray(impactsOnAbilityToPerformJobAnswer)) {
            return impactsOnAbilityToPerformJobAnswer as string[];
        }

        if (typeof impactsOnAbilityToPerformJobAnswer === "string") {
            return [impactsOnAbilityToPerformJobAnswer];
        }

        return [];
    }

    public updateSnippets = (snippetText: string, sectionId: string, id: string, questionText: string) => {
        const riskAssessmentRecommendationsAnswer = getAnswerToQuestionWithId(this.props.questions, id);
        const question = {
            question: questionText,
            answer: (riskAssessmentRecommendationsAnswer ? riskAssessmentRecommendationsAnswer + " " : "") + snippetText,
            isValid: true
        };
        this.props.updateAnswer({ sectionId, id, question });
    };

    public openIAPTQuestionnaireModal() {
        this.setState({ iaptQuestionnaireModalOpen: true, iaptQuestionnaireModalSubmitted: false });

        this.updatePhq9Score();
        this.updateGad7Score();
        this.updateWsasScore();

        const iaptCarryOutPhq9Assessment = getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutPhq9Assessment) === YesOption;
        const iaptCarryOutGad7Assessment = getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutGad7Assessment) === YesOption;
        const iaptCarryOutWsasAssessment = getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutWsasAssessment) === YesOption;

        if (!iaptCarryOutPhq9Assessment) {

            const iaptCarryOutPhq9AssessmentQuestion: AnsweredQuestion = {
                id: iaptQuestionIds.IaptCarryOutPhq9Assessment,
                answer: NoOption,
                question: (getQuestionConfig(iaptMasterConfig, iaptQuestionIds.IaptCarryOutPhq9Assessment) as CustomQuestionConfig).questionText,
                isValid: true,
                sectionId: this.iaptQuestionnaireSectionId
            };

            this.props.updateAnswer({
                sectionId: this.iaptQuestionnaireSectionId,
                id: iaptQuestionIds.IaptCarryOutPhq9Assessment,
                question: iaptCarryOutPhq9AssessmentQuestion
            });
        }

        if (!iaptCarryOutGad7Assessment) {

            const iaptCarryOutGad7AssessmentQuestion: AnsweredQuestion = {
                id: iaptQuestionIds.IaptCarryOutGad7Assessment,
                answer: NoOption,
                question: (getQuestionConfig(iaptMasterConfig, iaptQuestionIds.IaptCarryOutGad7Assessment) as CustomQuestionConfig).questionText,
                isValid: true,
                sectionId: this.iaptQuestionnaireSectionId
            };

            this.props.updateAnswer({
                sectionId: this.iaptQuestionnaireSectionId,
                id: iaptQuestionIds.IaptCarryOutGad7Assessment,
                question: iaptCarryOutGad7AssessmentQuestion
            });
        }

        if (!iaptCarryOutWsasAssessment) {

            const iaptCarryOutWsasAssessmentQuestion: AnsweredQuestion = {
                id: iaptQuestionIds.IaptCarryOutWsasAssessment,
                answer: NoOption,
                question: (getQuestionConfig(iaptMasterConfig, iaptQuestionIds.IaptCarryOutWsasAssessment) as CustomQuestionConfig).questionText,
                isValid: true,
                sectionId: this.iaptQuestionnaireSectionId
            };

            this.props.updateAnswer({
                sectionId: this.iaptQuestionnaireSectionId,
                id: iaptQuestionIds.IaptCarryOutWsasAssessment,
                question: iaptCarryOutWsasAssessmentQuestion
            });
        }
    }

    public submitIAPTQuestionnaireModal() {
        this.setState({ iaptQuestionnaireModalSubmitted: true });

        if (iaptMasterConfig.some(m => !this.props.questions.some(q => m.id === q.id)) ||
            !this.props.questions.filter(q => iaptMasterConfig.some(m => m.id === q.id)).every(question => question.isValid)) {
            this.onTabChange(0);
            return;
        }

        const iaptCarryOutPhq9Assessment = getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutPhq9Assessment) === YesOption;
        const iaptCarryOutGad7Assessment = getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutGad7Assessment) === YesOption;
        const iaptCarryOutWsasAssessment = getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutWsasAssessment) === YesOption;

        if (iaptCarryOutPhq9Assessment) {
            if (iaptPhq9MasterConfig.some(m => !this.props.questions.some(q => m.id === q.id)) ||
                !this.props.questions.filter(q => iaptPhq9MasterConfig.some(m => m.id === q.id)).every(question => question.isValid)) {
                this.onTabChange(1);
                return;
            }
        }

        if (iaptCarryOutGad7Assessment) {
            if (iaptGad7MasterConfig.some(m => !this.props.questions.some(q => m.id === q.id)) ||
                !this.props.questions.filter(q => iaptGad7MasterConfig.some(m => m.id === q.id)).every(question => question.isValid)) {
                this.onTabChange(2);
                return;
            }
        }

        if (iaptCarryOutWsasAssessment) {
            if (iaptWsasMasterConfig.some(m => !this.props.questions.some(q => m.id === q.id)) ||
                !this.props.questions.filter(q => iaptWsasMasterConfig.some(m => m.id === q.id)).every(question => question.isValid)) {
                this.onTabChange(3);
                return;
            }
        }

        this.updatePhq9Score();
        this.updateGad7Score();
        this.updateWsasScore();

        const iaptCarryOutIaptAssessmentQuestion: AnsweredQuestion = {
            id: iaptQuestionIds.IaptCarryOutIaptAssessment,
            answer: YesOption,
            question: iaptQuestionIds.IaptCarryOutIaptAssessment,
            isValid: true,
            sectionId: this.iaptQuestionnaireSectionId
        };

        this.props.updateAnswer({
            sectionId: this.iaptQuestionnaireSectionId,
            id: iaptQuestionIds.IaptCarryOutIaptAssessment,
            question: iaptCarryOutIaptAssessmentQuestion
        });

        this.setState({ iaptQuestionnaireModalOpen: false });
    }

    public closeQuestionaireModal() {
        this.setState({
            iaptQuestionnaireModalSubmitted: false,
            iaptQuestionnaireModalOpen: false
        });
    }

    private handleTabChange(event: React.MouseEvent<HTMLDivElement, MouseEvent>, data: TabProps) {
        this.setState({ iaptModalActiveIndex: Number(data.activeIndex) });
    }

    private onTabChange(tabIndex: number) {
        this.setState({ iaptModalActiveIndex: tabIndex });
    }

    private warningTextHeader(alwaysShow: boolean = false): React.ReactNode {
        if (this.props.customer.useToyotaTemplates || alwaysShow) {
            return <p className="question-red">Answers to questions displayed in red text will be added to the report</p>;
        }
        return "";
    }

    private getQuestionClassName(): string {
        return this.props.customer.useToyotaTemplates ? "question-red" : "";
    }

    private updatePhq9Score(currentQuestionId?: string, currentAnswer?: string) {
        if (this.props.readonly ||
            getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutPhq9Assessment) !== YesOption) {
            return;
        }

        const phq9TotalQuestionId = "PsychologicalWellbeingPHQ9Score";

        const phq9TotalQuestion = this.props.questions.find(q => q.id === phq9TotalQuestionId);

        if (currentQuestionId === iaptQuestionIds.IaptCarryOutPhq9Assessment) {
            if (currentAnswer !== YesOption) {
                this.props.updateAnswer({
                    sectionId: "PsychologicalAssessment",
                    id: phq9TotalQuestionId,
                    question: { ...phq9TotalQuestion!, answer: null }
                });

                this.onPsychologicalWellbeingScoreChange(
                    "PsychologicalWellbeingPHQ9Outcome",
                    "PHQ9 Outcome",
                    ""
                );
            }

            return;
        }

        let phq9Answers = this.props.questions.filter(q => iaptPhq9MasterConfig.some(m => m.id === q.id));

        if (currentQuestionId) {
            phq9Answers = phq9Answers.filter(q => q.id !== currentQuestionId);
        }

        let phq9Score = phq9Answers
            .map(q => iaptQuestionnaireAnswers.find(a => a.text === q.answer?.toString())?.score)
            .reduce((sum, current) => (sum ?? 0) + (!!current && !isNaN(current) ? current : 0), 0);

        if (currentAnswer) {
            const currentQuestionScore = iaptQuestionnaireAnswers.find(a => a.text === currentAnswer)?.score;

            phq9Score = (!!currentQuestionScore && !isNaN(currentQuestionScore) ? currentQuestionScore : 0) + (phq9Score ?? 0);
        }

        this.props.updateAnswer({
            sectionId: "PsychologicalAssessment",
            id: phq9TotalQuestionId,
            question: { ...phq9TotalQuestion!, answer: phq9Score }
        });

        this.setState({ psychologicalWellbeingPHQ9Score: phq9Score ?? 0 });
    }

    private updateGad7Score(currentQuestionId?: string, currentAnswer?: string) {
        if (this.props.readonly ||
            getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutGad7Assessment) !== YesOption) {
            return;
        }

        const gad7TotalQuestionId = "PsychologicalWellbeingGAD7Score";

        const gad7TotalQuestion = this.props.questions.find(q => q.id === gad7TotalQuestionId);

        if (currentQuestionId === iaptQuestionIds.IaptCarryOutGad7Assessment) {
            if (currentAnswer !== YesOption) {
                this.props.updateAnswer({
                    sectionId: "PsychologicalAssessment",
                    id: gad7TotalQuestionId,
                    question: { ...gad7TotalQuestion!, answer: null }
                });

                this.onPsychologicalWellbeingScoreChange(
                    "PsychologicalWellbeingGAD7Outcome",
                    "GAD7 Outcome",
                    ""
                );
            }

            return;
        }

        let gad7Answers = this.props.questions.filter(q => iaptGad7MasterConfig.some(m => m.id === q.id));

        if (currentQuestionId) {
            gad7Answers = gad7Answers.filter(q => q.id !== currentQuestionId);
        }

        let gad7Score = gad7Answers
            .map(q => iaptQuestionnaireAnswers.find(a => a.text === q.answer?.toString())?.score)
            .reduce((sum, current) => (sum ?? 0) + (!!current && !isNaN(current) ? current : 0), 0);

        if (currentAnswer) {
            const currentQuestionScore = iaptQuestionnaireAnswers.find(a => a.text === currentAnswer)?.score;

            gad7Score = (!!currentQuestionScore && !isNaN(currentQuestionScore) ? currentQuestionScore : 0) + (gad7Score ?? 0);
        }

        this.props.updateAnswer({
            sectionId: "PsychologicalAssessment",
            id: gad7TotalQuestionId,
            question: { ...gad7TotalQuestion!, answer: gad7Score }
        });

        this.setState({ psychologicalWellbeingGAD7Score: gad7Score ?? 0 });
    }

    private updateWsasScore(currentQuestionId?: string, currentAnswer?: string) {
        if (this.props.readonly ||
            getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutWsasAssessment) !== YesOption) {
            return;
        }

        const wsasTotalQuestionId = "PsychologicalWellbeingWSASScore";

        const wsasTotalQuestion = this.props.questions.find(q => q.id === wsasTotalQuestionId);

        if (!wsasTotalQuestion)
        {
            return;
        }

        if (currentQuestionId === iaptQuestionIds.IaptCarryOutWsasAssessment) {
            if (currentAnswer !== YesOption) {
                this.props.updateAnswer({
                    sectionId: "PsychologicalAssessment",
                    id: wsasTotalQuestionId,
                    question: { ...wsasTotalQuestion, answer: null }
                });

                this.onPsychologicalWellbeingScoreChange(
                    "PsychologicalWellbeingWSASOutcome",
                    "WSAS Outcome",
                    ""
                );
            }

            return;
        }

        let wsasAnswers = this.props.questions.filter(q => iaptWsasMasterConfig.some(m => m.id === q.id));

        if (currentQuestionId) {
            wsasAnswers = wsasAnswers.filter(q => q.id !== currentQuestionId);
        }

        let wsasScore = wsasAnswers
            .map(q => q.answer?.toString() ? Number(q.answer?.toString()) : 0)
            .reduce((sum, current) => sum + (!!current && !isNaN(current) ? current : 0), 0);

        if (currentAnswer) {
            const currentQuestionScore = Number(currentAnswer);

            wsasScore = (!!currentQuestionScore && !isNaN(currentQuestionScore) ? currentQuestionScore : 0) + wsasScore;
        }

        this.props.updateAnswer({
            sectionId: "PsychologicalAssessment",
            id: wsasTotalQuestionId,
            question: { ...wsasTotalQuestion, answer: wsasScore }
        });

        this.setState({ psychologicalWellbeingWSASScore: wsasScore });
    }

    private updateIaptAnswer(questionId: string, question: AnsweredQuestion) {
        if (this.props.readonly) {
            return;
        }

        if (questionId === iaptQuestionIds.IaptCarryOutPhq9Assessment ||
            iaptPhq9MasterConfig.some(m => m.id === questionId)) {
            this.updatePhq9Score(questionId, question.answer?.toString());
        }

        if (questionId === iaptQuestionIds.IaptCarryOutGad7Assessment ||
            iaptGad7MasterConfig.some(m => m.id === questionId)) {
            this.updateGad7Score(questionId, question.answer?.toString());
        }

        if (questionId === iaptQuestionIds.IaptCarryOutWsasAssessment ||
            iaptWsasMasterConfig.some(m => m.id === questionId)) {
            this.updateWsasScore(questionId, question.answer?.toString());
        }

        this.props.updateAnswer({
            sectionId: this.iaptQuestionnaireSectionId,
            id: questionId,
            question
        });
    }

    public render() {

        const iaptModalTabs = [
            {
                // Any changes made to content of iaptModalTabs should reflect
                // in the file - Admin.App\src\clinicalNotes\components\IaptViewCompletedQuestionnaire.tsx
                menuItem: "Personal Information",
                render: () => {
                    return (
                        <Tab.Pane attached={false}>
                            <TextQuestion
                                inline
                                hideDivider
                                readonly={true}
                                questionConfig={({
                                    id: "IaptEmployeeName",
                                    questionText: "Employee Name"
                                })}
                                updateQuestion={(question) => this.props.updateAnswer({
                                    sectionId: this.iaptQuestionnaireSectionId,
                                    id: "IaptEmployeeName",
                                    question
                                })}
                                answer={`${this.props.ohCase.employeeFirstName} ${this.props.ohCase.employeeLastName}`}
                            />
                            <TextQuestion
                                inline
                                hideDivider
                                readonly={true}
                                questionConfig={({
                                    id: "IaptJobRole",
                                    questionText: "Job Role"
                                })}
                                updateQuestion={(question) => this.props.updateAnswer({
                                    sectionId: this.iaptQuestionnaireSectionId,
                                    id: "IaptJobRole",
                                    question
                                })}
                                answer={this.props.ohCase.jobTitle}
                            />
                            <TextQuestion
                                readonly={true}
                                hidden={true}
                                questionConfig={({
                                    id: iaptQuestionIds.IaptCarryOutIaptAssessment,
                                    questionText: iaptQuestionIds.IaptCarryOutIaptAssessment
                                })}
                                answer={YesOption}
                            />
                            <br />
                            <Button type={"button"} content="Next" onClick={() => this.onTabChange(1)} />
                        </Tab.Pane>
                    );
                }
            },
            {
                // Any changes made to content of iaptModalTabs should reflect
                // in the file - Admin.App\src\clinicalNotes\components\IaptViewCompletedQuestionnaire.tsx
                menuItem: "PHQ9",
                render: () => {
                    return (
                        <Tab.Pane attached={false}>
                            <MultiButtonQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={getQuestionConfig(iaptMasterConfig, iaptQuestionIds.IaptCarryOutPhq9Assessment)}
                                mandatory
                                updateQuestion={(question) => this.updateIaptAnswer(
                                    iaptQuestionIds.IaptCarryOutPhq9Assessment,
                                    question
                                )}
                                answer={getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutPhq9Assessment)}
                                showError={this.state.iaptQuestionnaireModalSubmitted}
                            />
                            {getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutPhq9Assessment) === YesOption &&
                                <>
                                    <h4>Over the last 2 weeks, how often have you been bothered by any of the following problems?</h4>
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptPhq9MasterConfig, iaptPhq9QuestionIds.IaptLittleInterestOrPleasureInDoingThings)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptPhq9QuestionIds.IaptLittleInterestOrPleasureInDoingThings,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptPhq9QuestionIds.IaptLittleInterestOrPleasureInDoingThings)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptPhq9MasterConfig, iaptPhq9QuestionIds.IaptFeelingDownDepressedOrHopeless)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptPhq9QuestionIds.IaptFeelingDownDepressedOrHopeless,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptPhq9QuestionIds.IaptFeelingDownDepressedOrHopeless)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(
                                            iaptPhq9MasterConfig,
                                            iaptPhq9QuestionIds.IaptTroubleFallingOrStayingAsleepOrSleepingTooMuch)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptPhq9QuestionIds.IaptTroubleFallingOrStayingAsleepOrSleepingTooMuch,
                                            question)}
                                        answer={getAnswerToQuestionWithId(
                                            this.props.questions,
                                            iaptPhq9QuestionIds.IaptTroubleFallingOrStayingAsleepOrSleepingTooMuch)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptPhq9MasterConfig, iaptPhq9QuestionIds.IaptFeelingTiredOrHavingLittleEnergy)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptPhq9QuestionIds.IaptFeelingTiredOrHavingLittleEnergy,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptPhq9QuestionIds.IaptFeelingTiredOrHavingLittleEnergy)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptPhq9MasterConfig, iaptPhq9QuestionIds.IaptPoorAppetiteOrOvereating)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptPhq9QuestionIds.IaptPoorAppetiteOrOvereating,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptPhq9QuestionIds.IaptPoorAppetiteOrOvereating)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptPhq9MasterConfig, iaptPhq9QuestionIds.IaptFeelingBadAboutYourself)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptPhq9QuestionIds.IaptFeelingBadAboutYourself,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptPhq9QuestionIds.IaptFeelingBadAboutYourself)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(
                                            iaptPhq9MasterConfig,
                                            iaptPhq9QuestionIds.IaptTroubleConcentratingOnReadingOrWatching)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptPhq9QuestionIds.IaptTroubleConcentratingOnReadingOrWatching,
                                            question)}
                                        answer={getAnswerToQuestionWithId(
                                            this.props.questions,
                                            iaptPhq9QuestionIds.IaptTroubleConcentratingOnReadingOrWatching)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptPhq9MasterConfig, iaptPhq9QuestionIds.IaptMovingOrSpeakingSoSlowly)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptPhq9QuestionIds.IaptMovingOrSpeakingSoSlowly,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptPhq9QuestionIds.IaptMovingOrSpeakingSoSlowly)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(
                                            iaptPhq9MasterConfig,
                                            iaptPhq9QuestionIds.IaptThoughtsThatWouldBeBetterOffDeadOrOfHurtingYourself)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptPhq9QuestionIds.IaptThoughtsThatWouldBeBetterOffDeadOrOfHurtingYourself,
                                            question)}
                                        answer={getAnswerToQuestionWithId(
                                            this.props.questions,
                                            iaptPhq9QuestionIds.IaptThoughtsThatWouldBeBetterOffDeadOrOfHurtingYourself)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={true}
                                        questionConfig={({
                                            id: "IaptPsychologicalWellbeingPHQ9Score",
                                            questionText: "PHQ9 Score (These comments will be added to your report)"
                                        })}
                                        questionClassName={"question-red"}
                                        answer={this.state.psychologicalWellbeingPHQ9Score}
                                    />
                                </>
                            }
                            <br />
                            <Button type={"button"} content="Next" onClick={() => this.onTabChange(2)} />
                        </Tab.Pane>
                    );
                }
            },
            {
                // Any changes made to content of iaptModalTabs should reflect
                // in the file - Admin.App\src\clinicalNotes\components\IaptViewCompletedQuestionnaire.tsx
                menuItem: "GAD7",
                render: () => {
                    return (
                        <Tab.Pane attached={false}>
                            <MultiButtonQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={getQuestionConfig(iaptMasterConfig, iaptQuestionIds.IaptCarryOutGad7Assessment)}
                                mandatory
                                updateQuestion={(question) => this.updateIaptAnswer(
                                    iaptQuestionIds.IaptCarryOutGad7Assessment,
                                    question
                                )}
                                answer={getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutGad7Assessment)}
                                showError={this.state.iaptQuestionnaireModalSubmitted}
                            />
                            {getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutGad7Assessment) === YesOption &&
                                <>
                                    <h4>Over the last 2 weeks, how often have you been bothered by any of the following problems?</h4>
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptGad7MasterConfig, iaptGad7QuestionIds.IaptFeelingNervousAnxiousOrOnEdge)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptGad7QuestionIds.IaptFeelingNervousAnxiousOrOnEdge,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptGad7QuestionIds.IaptFeelingNervousAnxiousOrOnEdge)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptGad7MasterConfig, iaptGad7QuestionIds.IaptNotBeingAbleToStopOrControlWorrying)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptGad7QuestionIds.IaptNotBeingAbleToStopOrControlWorrying,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptGad7QuestionIds.IaptNotBeingAbleToStopOrControlWorrying)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptGad7MasterConfig, iaptGad7QuestionIds.IaptWorryingTooMuchAboutDifferentThings)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptGad7QuestionIds.IaptWorryingTooMuchAboutDifferentThings,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptGad7QuestionIds.IaptWorryingTooMuchAboutDifferentThings)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptGad7MasterConfig, iaptGad7QuestionIds.IaptTroubleRelaxing)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptGad7QuestionIds.IaptTroubleRelaxing,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptGad7QuestionIds.IaptTroubleRelaxing)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptGad7MasterConfig, iaptGad7QuestionIds.IaptBeingSoRestlessThatItIsHardToSitStill)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptGad7QuestionIds.IaptBeingSoRestlessThatItIsHardToSitStill,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptGad7QuestionIds.IaptBeingSoRestlessThatItIsHardToSitStill)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptGad7MasterConfig, iaptGad7QuestionIds.IaptBecomingEasilyAnnoyedOrIrritable)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptGad7QuestionIds.IaptBecomingEasilyAnnoyedOrIrritable,
                                            question)}
                                        answer={getAnswerToQuestionWithId(
                                            this.props.questions,
                                            iaptGad7QuestionIds.IaptBecomingEasilyAnnoyedOrIrritable)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(
                                            iaptGad7MasterConfig,
                                            iaptGad7QuestionIds.IaptFeelingAfraidAsIfSomethingAwfulMightHappen)}
                                        mandatory
                                        values={iaptQuestionnaireAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptGad7QuestionIds.IaptFeelingAfraidAsIfSomethingAwfulMightHappen,
                                            question)}
                                        answer={getAnswerToQuestionWithId(
                                            this.props.questions,
                                            iaptGad7QuestionIds.IaptFeelingAfraidAsIfSomethingAwfulMightHappen)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={true}
                                        questionConfig={({
                                            id: "PsychologicalWellbeingGAD7Score",
                                            questionText: "GAD7 Score (These comments will be added to your report)"
                                        })}
                                        questionClassName={"question-red"}
                                        answer={this.state.psychologicalWellbeingGAD7Score}
                                    />
                                </>
                            }
                            <br />
                            <Button type={"button"} content="Next" onClick={() => this.onTabChange(3)} />
                        </Tab.Pane>
                    );
                }
            },
            {
                // Any changes made to content of iaptModalTabs should reflect
                // in the file - Admin.App\src\clinicalNotes\components\IaptViewCompletedQuestionnaire.tsx
                menuItem: "WSAS",
                render: () => {
                    return (
                        <Tab.Pane attached={false}>
                            <MultiButtonQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={getQuestionConfig(iaptMasterConfig, iaptQuestionIds.IaptCarryOutWsasAssessment)}
                                mandatory
                                updateQuestion={(question) => this.updateIaptAnswer(
                                    iaptQuestionIds.IaptCarryOutWsasAssessment,
                                    question
                                )}
                                answer={getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutWsasAssessment)}
                                showError={this.state.iaptQuestionnaireModalSubmitted}
                            />
                            {getAnswerToQuestionWithId(this.props.questions, iaptQuestionIds.IaptCarryOutWsasAssessment) === YesOption &&
                                <>
                                    <h4>People’s problems sometimes affect their ability to do certain day-to-day tasks in their lives.
                                    To rate your problems, look at each section and determine on the scale provided how much your problem impairs
                                    your ability to carry out the activity.
                                    </h4>
                                    {!this.props.readonly &&
                                    <>
                                        <h4> Scale: 0 - Not at all, 2 - Slightly, 4 - Definitely, 6 - Markedly, Severely 8</h4>
                                        <br />
                                    </>
                                    }
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptWsasMasterConfig, iaptWsasQuestionIds.IaptWork)}
                                        mandatory
                                        values={iaptQuestionnaireWsasAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptWsasQuestionIds.IaptWork,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptWsasQuestionIds.IaptWork)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptWsasMasterConfig, iaptWsasQuestionIds.IaptHomeManagement)}
                                        mandatory
                                        values={iaptQuestionnaireWsasAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptWsasQuestionIds.IaptHomeManagement,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptWsasQuestionIds.IaptHomeManagement)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptWsasMasterConfig, iaptWsasQuestionIds.IaptSocialLeisureActivities)}
                                        mandatory
                                        values={iaptQuestionnaireWsasAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptWsasQuestionIds.IaptSocialLeisureActivities,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptWsasQuestionIds.IaptSocialLeisureActivities)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptWsasMasterConfig, iaptWsasQuestionIds.IaptPrivateLeisureActivities)}
                                        mandatory
                                        values={iaptQuestionnaireWsasAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptWsasQuestionIds.IaptPrivateLeisureActivities,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptWsasQuestionIds.IaptPrivateLeisureActivities)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <MultiButtonQuestion
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={getQuestionConfig(iaptWsasMasterConfig, iaptWsasQuestionIds.IaptFamilyAndRelationships)}
                                        mandatory
                                        values={iaptQuestionnaireWsasAnswerOptions}
                                        updateQuestion={(question) => this.updateIaptAnswer(
                                            iaptWsasQuestionIds.IaptFamilyAndRelationships,
                                            question)}
                                        answer={getAnswerToQuestionWithId(this.props.questions, iaptWsasQuestionIds.IaptFamilyAndRelationships)}
                                        showError={this.state.iaptQuestionnaireModalSubmitted}
                                    />
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={true}
                                        questionConfig={({
                                            id: "PsychologicalWellbeingWSASScore",
                                            questionText: "WSAS Score (These comments will be added to your report)"
                                        })}
                                        questionClassName={"question-red"}
                                        answer={this.state.psychologicalWellbeingWSASScore}
                                    />
                                </>
                            }
                        </Tab.Pane>
                    );
                }
            }
        ];

        if (this.props.isLoading) {
            return <Loader active />;
        }

        const chosenFunctionalAssessmentTests = this.getChosenFunctionalAssessmentTests();
        const chosenFunctionalAssessmentTestsConfigs = functionalAssessmentTestOptions.filter(
            ato => chosenFunctionalAssessmentTests.some(c => c === ato.value)
        );

        const chosenImpactsOnAbilityToPerformJobAnswer = this.getChosenImpactsOnAbilityToPerformJob();
        const chosenImpactsOnAbilityToPerformJobAnswerConfigs = impactOnAbilityToPerformJobQuestionOptions.filter(
            ioa => chosenImpactsOnAbilityToPerformJobAnswer.some(i => i === ioa.value)
        );

        const useSimplifiedNotesAndReport = getAnswerToQuestionWithId(this.props.questions, "SimplifiedNotesAndReport") === "UseSimplifiedNotesAndReport";

        const physioAssessmentFormVersionQuestionAnswer =
            getAnswerToQuestionWithId(this.props.questions, this.physioAssessmentFormVersionQuestion.id) as PhysioAssessmentFormVersion;
        const useFullAssessment = physioAssessmentFormVersionQuestionAnswer !== PhysioAssessmentFormVersion.ShortAssessment;

        const standardClinicalDetailsOriginTypeAnswer = getAnswerToQuestionWithId(this.props.questions, "StandardClinicalDetailsOriginType");

        const questionnaireContainerContent = (<>
            {this.props.readonly &&
                <>
                    <AccordionQuestionnaireSection
                        title="Consultation details"
                        key={this.consultationDetailsSectionId}
                        id={this.consultationDetailsSectionId}
                        index={1}
                    >
                        <OldDateQuestion readonly={true} questionConfig={this.startTimeQuestion} />
                        <OldDateQuestion readonly={true} questionConfig={this.finishTimeQuestion} />
                        <TextQuestion readonly={true} questionConfig={this.clinicianNameQuestion} />
                    </AccordionQuestionnaireSection>
                </>
            }
            <>
                <AccordionQuestionnaireSection
                    title="Completed on Behalf of"
                    key={this.completedOnBehalfOfSectionId}
                    id={this.completedOnBehalfOfSectionId}
                    index={2}
                >
                    {/* The question below is only to keep the chosen physio form mode (full/30min) for the auto-save */}
                    <TextQuestion
                        hidden
                        questionConfig={this.physioAssessmentFormVersionQuestion}
                        readonly
                    />
                    <DropdownQuestion
                        inline
                        hideDivider
                        readonly={this.props.readonly}
                        questionConfig={this.completedOnBehalfOfQuestion}
                        options={this.props.adminUsers.map(u => ({
                            text: getUserDisplayName(u) ?? "",
                            value: u.id
                        }))}
                        search
                        selectOnBlur={false}
                    />
                    {this.props.isOhp && !this.props.customer.useToyotaTemplates ? (
                        <>
                            <CheckboxQuestion
                                readonly={this.props.readonly}
                                hideDivider
                                questionConfig={({
                                    id: "SimplifiedNotesAndReportInvoker",
                                    questionText: "Tick here for simplified OHP notes and report. (OHP use only)"
                                })}
                                value="UseSimplifiedNotesAndReport"
                                onAnswerChange={this.onSimplifiedNotesAndReportInvokerChange}
                            />
                            <Confirm
                                open={this.state.simplifiedNotesAndReportConfirmationOpen}
                                content={"By doing this action, you will be removing previously written content on this form. Are you sure you want to "
                                    + "continue?"}
                                questionConfig={({
                                    id: "SimplifiedNotesAndReport",
                                    questionText: "Tick here for simplified OHP notes and report. (OHP use only)"
                                })}
                                onCancel={this.cancelSimplifiedNotesAndReportChange}
                                onConfirm={this.confirmSimplifiedNotesAndReportChange}
                            />
                        </>
                    ) : ("")}
                </AccordionQuestionnaireSection>
                <ReferralIntroductionAndDataPrivacySection ohCase={this.props.ohCase} employeeRecord={this.props.employeeRecord} />
            </>
            {useSimplifiedNotesAndReport
                ? (
                    <>
                        <AccordionQuestionnaireSection
                            title="Notes"
                            key="Notes"
                            id="Notes"
                            index={4}
                        >
                            <TextQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({ id: "Notes", questionText: "Notes" })}
                                multiline
                                rowCount={48}
                                mandatory
                                textSnippetSelector={
                                    <TextSnippetSelector
                                        padded
                                        onSelect={(selectedSnippet) => this.updateSnippets(
                                            selectedSnippet,
                                            "Notes",
                                            "Notes",
                                            "Notes"
                                        )}
                                    />
                                }
                            />
                        </AccordionQuestionnaireSection>
                    </>
                ) : (
                    <>
                        <AccordionQuestionnaireSection
                            title="Standard Clinical Details"
                            key="StandardClinicalDetails"
                            id="StandardClinicalDetails"
                            index={5}
                        >
                            {this.warningTextHeader()}
                            <TextQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "StandardClinicalDetailsReasonForReferral",
                                    questionText: "Reason for Referral and history of present complaint"
                                })}
                                multiline
                                textSnippetSelector={
                                    <TextSnippetSelector
                                        padded
                                        onSelect={(selectedSnippet) => this.updateSnippets(
                                            selectedSnippet,
                                            "StandardClinicalDetails",
                                            "StandardClinicalDetailsReasonForReferral",
                                            "Reason for Referral and history of present complaint"
                                        )}
                                    />
                                }
                            />
                            <NumberQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "StandardClinicalDetailsNumberOfDaysOffWorkDueToThisConditionInTheLast12Months",
                                    questionText: "No of days off work due to this condition in the last 12 months:"
                                })}
                                min={0}
                                max={366}
                            />
                            <OldDateQuestion
                                hideDivider
                                inline
                                mandatory={true}
                                readonly={this.props.readonly}
                                questionConfig={({ id: "StandardClinicalDetailsOnsetDate", questionText: "Onset Date" })}
                                questionClassName={this.getQuestionClassName()}
                                validators={[createValidator((value: moment.Moment) => isDateInThePast(value), "Should be today or in the past")]}
                            />
                            <OldDateQuestion
                                hideDivider
                                inline
                                mandatory={true}
                                readonly={this.props.readonly}
                                questionConfig={({ id: "DateIssueFirstRaised", questionText: "Date issue first raised to Employer" })}
                                outdated={{
                                    isOutdated: false,
                                    questionnaireKey,
                                    sectionId: "StandardClinicalDetails"
                                }}
                                questionClassName={this.getQuestionClassName()}
                                validators={[createValidator((value: moment.Moment) => isDateInThePast(value), "Should be today or in the past")]}
                            />
                            {useFullAssessment && <>
                                <MultiButtonQuestion
                                    hideDivider
                                    inline
                                    mandatory={true}
                                    readonly={this.props.readonly}
                                    questionConfig={({ id: "StandardClinicalDetailsFirstEpisode", questionText: "First Episode" })}
                                    outdated={{
                                        isOutdated: false,
                                        questionnaireKey,
                                        sectionId: "StandardClinicalDetails"
                                    }}
                                    questionClassName={this.getQuestionClassName()}
                                />
                                <DropdownQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "Symptoms",
                                        questionText: "Symptoms"
                                    })}
                                    outdated={{
                                        isOutdated: false,
                                        questionnaireKey,
                                        sectionId: "StandardClinicalDetails"
                                    }}
                                    options={symptomsOptions}
                                    questionClassName={this.getQuestionClassName()}
                                    mandatory
                                    multiple
                                />
                                <MultiButtonQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "StandardClinicalDetailsChronicProblem",
                                        questionText: "Chronic / recurrent problem",
                                        questionElement: (<ul className={"question-ul"}>
                                            <li>Chronic</li>
                                            <li>Recurrent problem</li>
                                        </ul>)
                                    })}
                                />
                            </>}
                            <DropdownQuestion
                                hideDivider
                                inline
                                mandatory={true}
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "StandardClinicalDetailsInjured",
                                    questionText: this.props.questions.find(q => q.id === "StandardClinicalDetailsInjured")?.question ?? "Origin"
                                })}
                                questionClassName={this.getQuestionClassName()}
                                filterOldOptions
                                options={injuredQuestionOptions}
                            />

                            { this.props.customer.useToyotaTemplates &&
                                <>
                                    <DropdownQuestion
                                        hideDivider
                                        inline
                                        mandatory={true}
                                        readonly={this.props.readonly}
                                        questionConfig={({ id: "StandardClinicalDetailsOriginType", questionText: "Origin Type" })}
                                        questionClassName={this.getQuestionClassName()}
                                        options={originTypeOptions}
                                    />
                                    {
                                        standardClinicalDetailsOriginTypeAnswer === OriginTypes.Accident && (
                                            <>
                                                <OldDateQuestion
                                                    hideDivider
                                                    inline
                                                    mandatory={true}
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "AccidentDate", questionText: "Accident Date" })}
                                                    validators={[createValidator(
                                                        (value: moment.Moment) => isDateInThePast(value),
                                                        "Should be today or in the past")]}
                                                />
                                                <TimeQuestion
                                                    hideDivider
                                                    inline={this.props.readonly}
                                                    questionConfig={({ id: "AccidentTime", questionText: "Accident Time" })}
                                                    readonly={this.props.readonly}
                                                    mandatory={true}
                                                />
                                                <TextQuestion
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "MemberAccidentStatement",
                                                        questionText: "Member Accident Statement"
                                                    })}
                                                    mandatory={true}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "StandardClinicalDetails",
                                                                "MemberAccidentStatement",
                                                                "Member Accident Statement"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "AccidentLocation",
                                                        questionText: "Accident Location"
                                                    })}
                                                    mandatory={true}
                                                />
                                                <DropdownQuestion
                                                    hideDivider
                                                    inline
                                                    mandatory={true}
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "AccidentOutcome", questionText: "Accident Outcome" })}
                                                    options={accidentOutcomeOptions}
                                                />
                                                <DropdownQuestion
                                                    hideDivider
                                                    inline
                                                    mandatory={true}
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "TypeOfInjury", questionText: "Type Of Injury" })}
                                                    options={typeOfInjuryOptions}
                                                    multiple
                                                />
                                                <Divider className={"question-red-top-border"} hidden={this.props.readonly} />
                                            </>
                                        )
                                    }
                                </>
                            }

                            {useFullAssessment &&
                                <TextQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "StandardClinicalDetailsCurrentCondition",
                                        questionText: "Current Condition / History of Present Complaint / Symptoms",
                                        questionElement: (<ul className={"question-ul"}>
                                            <li>Current condition</li>
                                            <li>History of present complaint</li>
                                            <li>Symptoms</li>
                                        </ul>)
                                    })}
                                    multiline
                                    textSnippetSelector={
                                        <TextSnippetSelector
                                            padded
                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                selectedSnippet,
                                                "StandardClinicalDetails",
                                                "StandardClinicalDetailsCurrentCondition",
                                                "Current Condition / History of Present Complaint / Symptoms"
                                            )}
                                        />
                                    }
                                />
                            }
                            <TextQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "StandardClinicalDetailsTreatmentInterventionsInvestigationsWithOutcomes",
                                    questionText: "Treatment / Interventions / Investigations with outcomes",
                                    questionElement: (<ul className={"question-ul"}>
                                        <li>Treatment</li>
                                        <li>Interventions</li>
                                        <li>Investigations with outcomes</li>
                                    </ul>)
                                })}
                                multiline
                                textSnippetSelector={
                                    <TextSnippetSelector
                                        padded
                                        onSelect={(selectedSnippet) => this.updateSnippets(
                                            selectedSnippet,
                                            "StandardClinicalDetails",
                                            "StandardClinicalDetailsTreatmentInterventionsInvestigationsWithOutcomes",
                                            "Treatment / Interventions / Investigations with outcomes"
                                        )}
                                    />
                                }
                            />
                            <TextQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({ id: "StandardClinicalDetailsPreviousMedicalHistory", questionText: "Previous Medical History" })}
                                multiline
                                textSnippetSelector={
                                    <TextSnippetSelector
                                        padded
                                        onSelect={(selectedSnippet) => this.updateSnippets(
                                            selectedSnippet,
                                            "StandardClinicalDetails",
                                            "StandardClinicalDetailsPreviousMedicalHistory",
                                            "Previous Medical History"
                                        )}
                                    />
                                }
                            />
                            <TextQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "StandardClinicalDetailsDrugMedicationHistory",
                                    questionText: "Drug / Medication History",
                                    questionElement: (<ul className={"question-ul"}>
                                        <li>Drug</li>
                                        <li>Medication history</li>
                                    </ul>)
                                })}
                                multiline
                                textSnippetSelector={
                                    <TextSnippetSelector
                                        padded
                                        onSelect={(selectedSnippet) => this.updateSnippets(
                                            selectedSnippet,
                                            "StandardClinicalDetails",
                                            "StandardClinicalDetailsDrugMedicationHistory",
                                            "Drug / Medication History"
                                        )}
                                    />
                                }
                            />
                            <TextQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({ id: "StandardClinicalDetailsCurrentJobRoleAndDuties", questionText: "Current job role and duties" })}
                                multiline
                                textSnippetSelector={
                                    <TextSnippetSelector
                                        padded
                                        onSelect={(selectedSnippet) => this.updateSnippets(
                                            selectedSnippet,
                                            "StandardClinicalDetails",
                                            "StandardClinicalDetailsCurrentJobRoleAndDuties",
                                            "Current job role and duties"
                                        )}
                                    />
                                }
                            />
                            <DropdownQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({ id: "StandardClinicalDetailsCurrentWorkStatus", questionText: "Current Work Status" })}
                                options={currentWorkStatusOptions}
                            />
                            {useFullAssessment &&
                                <MultiButtonQuestion
                                    inline
                                    hideDivider
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "StandardClinicalDetailsAnySecondOrAdditionalEmployment",
                                        questionText: "Any second or additional employment?"
                                    })}
                                />
                            }
                            {getAnswerToQuestionWithId(this.props.questions, "StandardClinicalDetailsAnySecondOrAdditionalEmployment") === YesOption &&
                                <>
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "StandardClinicalDetailsAnySecondOrAdditionalEmploymentDetails",
                                            questionText: "Details"
                                        })}
                                        multiline
                                        textSnippetSelector={
                                            <TextSnippetSelector
                                                padded
                                                onSelect={(selectedSnippet) => this.updateSnippets(
                                                    selectedSnippet,
                                                    "StandardClinicalDetails",
                                                    "StandardClinicalDetailsAnySecondOrAdditionalEmploymentDetails",
                                                    "Details"
                                                )}
                                            />
                                        }
                                    />
                                </>
                            }
                            <div className={"fields-divider"} />
                        </AccordionQuestionnaireSection>
                        {useFullAssessment && <>
                            <AccordionQuestionnaireSection
                                title="Functional Capacity"
                                key="FunctionalCapacity"
                                id="FunctionalCapacity"
                                index={6}
                            >
                                {this.warningTextHeader()}
                                <p className="clinical-notes-header">Functional Capacity Summary</p>
                                <MultiButtonQuestion
                                    inline
                                    hideDivider
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "FunctionalCapacityRestrictionsToADLWorkFunctionality",
                                        questionText: "Are there any restrictions to ADL's or work functionality?"
                                    })}
                                />
                                {useFullAssessment && <>
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "FunctionalCapacityRestrictionsToADLWorkFunctionalityDetails",
                                            questionText: "Details"
                                        })}
                                        multiline
                                        textSnippetSelector={
                                            <TextSnippetSelector
                                                padded
                                                onSelect={(selectedSnippet) => this.updateSnippets(
                                                    selectedSnippet,
                                                    "FunctionalCapacity",
                                                    "FunctionalCapacityRestrictionsToADLWorkFunctionalityDetails",
                                                    "Details"
                                                )}
                                            />
                                        }
                                    />
                                    <TextQuestion
                                        inline
                                        hideDivider
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "FunctionalCapacityCommentsOnFunctionalCapacity",
                                            questionText: "Comments on functional capacity (These comments will be added to your report)"
                                        })}
                                        questionClassName={"question-red"}
                                        multiline
                                        textSnippetSelector={
                                            <TextSnippetSelector
                                                padded
                                                onSelect={(selectedSnippet) => this.updateSnippets(
                                                    selectedSnippet,
                                                    "FunctionalCapacity",
                                                    "FunctionalCapacityCommentsOnFunctionalCapacity",
                                                    "Comments on functional capacity (These comments will be added to your report)"
                                                )}
                                            />
                                        }
                                    />
                                    <DropdownQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "FunctionalCapacityFunctionalAssessmentTests",
                                            questionText: "Add Specific Functional Assessment Test"
                                        })}
                                        options={functionalAssessmentTestOptions}
                                        multiple
                                    />
                                    <p className="clinical-notes-header additional-padding">Functional Assessment Tests</p>
                                    {chosenFunctionalAssessmentTestsConfigs.map(
                                        (assessmentTest: { text: string; value: string; type: FunctionalAssessmentTestType }) =>
                                            assessmentTest.type === FunctionalAssessmentTestType.Dropdown
                                                ? (
                                                    <DropdownQuestion
                                                        key={"FunctionalCapacity" + assessmentTest.value}
                                                        hideDivider
                                                        inline
                                                        readonly={this.props.readonly}
                                                        questionConfig={({
                                                            id: "FunctionalCapacity" + assessmentTest.value,
                                                            questionText: assessmentTest.text + " (These comments will be added to your report)"
                                                        })}
                                                        questionClassName={"question-red"}
                                                        options={dropdownFunctionalAssessmentTestOptions}
                                                        mandatory
                                                    />
                                                )
                                                : (
                                                    <>
                                                        <TextQuestion
                                                            hideDivider
                                                            inline
                                                            readonly={this.props.readonly}
                                                            questionConfig={({
                                                                id: "FunctionalCapacity" + assessmentTest.value,
                                                                questionText: assessmentTest.text + " (These comments will be added to your report)"
                                                            })}
                                                            questionClassName={"question-red"}
                                                            multiline
                                                            mandatory
                                                            textSnippetSelector={
                                                                <TextSnippetSelector
                                                                    padded
                                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                                        selectedSnippet,
                                                                        "FunctionalCapacity",
                                                                        "FunctionalCapacity" + assessmentTest.value,
                                                                        assessmentTest.text + " (These comments will be added to your report)"
                                                                    )}
                                                                />
                                                            }
                                                        />
                                                    </>
                                                )
                                    )}
                                </>}
                            </AccordionQuestionnaireSection>
                            <AccordionQuestionnaireSection
                                title="Social History"
                                key={this.socialHistorySectionId}
                                id={this.socialHistorySectionId}
                                index={7}
                            >
                                <MultiButtonQuestion
                                    inline
                                    hideDivider
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "SocialHistoryFamilyChildren",
                                        questionText: "Family / Children"
                                    })}
                                />
                                {getAnswerToQuestionWithId(this.props.questions, "SocialHistoryFamilyChildren") === YesOption &&
                                    <>
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({ id: "SocialHistoryFamilyChildrenDetails", questionText: "Details" })}
                                            multiline
                                            mandatory
                                            textSnippetSelector={
                                                <TextSnippetSelector
                                                    padded
                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                        selectedSnippet,
                                                        this.socialHistorySectionId,
                                                        "SocialHistoryFamilyChildrenDetails",
                                                        "Details"
                                                    )}
                                                />
                                            }
                                        />
                                    </>
                                }
                                <MultiButtonQuestion
                                    inline
                                    hideDivider
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "SocialHistoryLifeEventsFinancial",
                                        questionText: "Life Events / Financial"
                                    })}
                                />
                                {getAnswerToQuestionWithId(this.props.questions, "SocialHistoryLifeEventsFinancial") === YesOption &&
                                    <>
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({ id: "SocialHistoryLifeEventsFinancialDetails", questionText: "Details" })}
                                            multiline
                                            mandatory
                                            textSnippetSelector={
                                                <TextSnippetSelector
                                                    padded
                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                        selectedSnippet,
                                                        this.socialHistorySectionId,
                                                        "SocialHistoryLifeEventsFinancialDetails",
                                                        "Details"
                                                    )}
                                                />
                                            }
                                        />
                                    </>
                                }
                                <MultiButtonQuestion
                                    inline
                                    hideDivider
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "SocialHistorySleep",
                                        questionText: "Sleep"
                                    })}
                                />
                                {getAnswerToQuestionWithId(this.props.questions, "SocialHistorySleep") === YesOption &&
                                    <>
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({ id: "SocialHistorySleepDetails", questionText: "Details" })}
                                            multiline
                                            mandatory
                                            textSnippetSelector={
                                                <TextSnippetSelector
                                                    padded
                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                        selectedSnippet,
                                                        this.socialHistorySectionId,
                                                        "SocialHistorySleepDetails",
                                                        "Details"
                                                    )}
                                                />
                                            }
                                        />
                                    </>
                                }
                                <NumberQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "SocialHistoryAlcoholUnitsPerWeek",
                                        questionText: "Alcohol (units per week)"
                                    })}
                                />
                                <DropdownQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "SocialHistorySmokingStatus",
                                        questionText: "Smoking Status"
                                    })}
                                    options={smokingStatusQuestionOptions}
                                />
                                <DropdownQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "Diabetic",
                                        questionText: "Diabetic"
                                    })}
                                    outdated={{
                                        isOutdated: false,
                                        questionnaireKey,
                                        sectionId: this.socialHistorySectionId
                                    }}
                                    options={diabeticOptions}
                                />
                                <MultiButtonQuestion
                                    inline
                                    hideDivider
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "SocialHistoryRecreationalDrugs",
                                        questionText: "Recreational Drugs"
                                    })}
                                />
                                {getAnswerToQuestionWithId(this.props.questions, "SocialHistoryRecreationalDrugs") === YesOption &&
                                    <>
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({ id: "SocialHistoryRecreationalDrugsDetails", questionText: "Details" })}
                                            multiline
                                            mandatory
                                            textSnippetSelector={
                                                <TextSnippetSelector
                                                    padded
                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                        selectedSnippet,
                                                        this.socialHistorySectionId,
                                                        "SocialHistoryRecreationalDrugsDetails",
                                                        "Details"
                                                    )}
                                                />
                                            }
                                        />
                                    </>
                                }
                                <MultiButtonQuestion
                                    inline
                                    hideDivider
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "SocialHistoryHobbiesExercise",
                                        questionText: "Hobbies / Exercise"
                                    })}
                                />
                                {getAnswerToQuestionWithId(this.props.questions, "SocialHistoryHobbiesExercise") === YesOption &&
                                    <>
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({ id: "SocialHistoryHobbiesExerciseDetails", questionText: "Details" })}
                                            multiline
                                            mandatory
                                            textSnippetSelector={
                                                <TextSnippetSelector
                                                    padded
                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                        selectedSnippet,
                                                        this.socialHistorySectionId,
                                                        "SocialHistoryHobbiesExerciseDetails",
                                                        "Details"
                                                    )}
                                                />
                                            }
                                        />
                                    </>
                                }
                                <MultiButtonQuestion
                                    inline
                                    hideDivider
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "SocialHistoryDietNutrition",
                                        questionText: "Diet / Nutrition"
                                    })}
                                />
                                {getAnswerToQuestionWithId(this.props.questions, "SocialHistoryDietNutrition") === YesOption &&
                                    <>
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({ id: "SocialHistoryDietNutritionDetails", questionText: "Details" })}
                                            multiline
                                            mandatory
                                            textSnippetSelector={
                                                <TextSnippetSelector
                                                    padded
                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                        selectedSnippet,
                                                        this.socialHistorySectionId,
                                                        "SocialHistoryDietNutritionDetails",
                                                        "Details"
                                                    )}
                                                />
                                            }
                                        />
                                    </>
                                }
                            </AccordionQuestionnaireSection>
                            <AccordionQuestionnaireSection
                                title="Mental Health"
                                key="MentalHealth"
                                id="MentalHealth"
                                index={8}
                            >
                                {this.warningTextHeader()}
                                <MultiButtonQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "MentalHealthIndicationsOfAnUnderlyingMentalHealthConditionOrDiagnosis",
                                        questionText: "Are there any indications of an underlying mental health condition or diagnosis?"
                                    })}
                                />
                                <MultiButtonQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "MentalHealthSignsOfPsychologicalDistress",
                                        questionText: "Are there any signs of psychological distress?"
                                    })}
                                />
                                <TextQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "MentalHealthCommentsOnMentalAndEmotionalWellbeing",
                                        questionText: "Comments on Mental and Emotional Wellbeing (These comments will be added to your report)"
                                    })}
                                    questionClassName={"question-red"}
                                    multiline
                                    textSnippetSelector={
                                        <TextSnippetSelector
                                            padded
                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                selectedSnippet,
                                                "MentalHealth",
                                                "MentalHealthCommentsOnMentalAndEmotionalWellbeing",
                                                "Comments on Mental and Emotional Wellbeing (These comments will be added to your report)"
                                            )}
                                        />
                                    }
                                />
                            </AccordionQuestionnaireSection>
                            <AccordionQuestionnaireSection
                                title="Psychological Assessment"
                                key="PsychologicalAssessment"
                                id="PsychologicalAssessment"
                                index={9}
                            >
                                <MultiButtonQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "CarryOutPsychologicalAssessment",
                                        questionText: "Do you wish to carry out a psychological assessment?"
                                    })}
                                    mandatory
                                    onAnswerChange={this.onCarryOutPsychologicalAssessmentChange}
                                />
                                {getAnswerToQuestionWithId(this.props.questions, "CarryOutPsychologicalAssessment") === YesOption &&
                                    <>
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingSignsOfNeglect",
                                                questionText: "Signs of neglect"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingSignsOfNeglect") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingSignsOfNeglectDetails",
                                                        questionText: "Details"
                                                    })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingSignsOfNeglectDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingSpeech",
                                                questionText: "Speech"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingSpeech") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "PsychologicalWellbeingSpeechDetails", questionText: "Details" })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingSpeechDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingPerception",
                                                questionText: "Perception"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingPerception") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingPerceptionDetails",
                                                        questionText: "Details"
                                                    })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingPerceptionDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingInterest",
                                                questionText: "Interest"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingInterest") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "PsychologicalWellbeingInterestDetails", questionText: "Details" })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingInterestDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingSleep",
                                                questionText: "Sleep"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingSleep") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "PsychologicalWellbeingSleepDetails", questionText: "Details" })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingSleepDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingAppetite",
                                                questionText: "Appetite"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingAppetite") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "PsychologicalWellbeingAppetiteDetails", questionText: "Details" })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingAppetiteDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingMood",
                                                questionText: "Mood"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingMood") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "PsychologicalWellbeingMoodDetails", questionText: "Details" })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingMoodDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingMemory",
                                                questionText: "Memory"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingMemory") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "PsychologicalWellbeingMemoryDetails", questionText: "Details" })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingMemoryDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingConcentration",
                                                questionText: "Concentration"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingConcentration") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingConcentrationDetails",
                                                        questionText: "Details"
                                                    })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingConcentrationDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingActivity",
                                                questionText: "Activity"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingActivity") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "PsychologicalWellbeingActivityDetails", questionText: "Details" })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingActivityDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingGuilt",
                                                questionText: "Guilt"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingGuilt") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "PsychologicalWellbeingGuiltDetails", questionText: "Details" })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingGuiltDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingEnergy",
                                                questionText: "Energy"
                                            })}
                                            mandatory
                                        />
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingEnergy") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({ id: "PsychologicalWellbeingEnergyDetails", questionText: "Details" })}
                                                    multiline
                                                    mandatory
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingEnergyDetails",
                                                                "Details"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <Modal open={this.state.iaptQuestionnaireModalOpen} size="large" closeOnDimmerClick={false}>
                                            <Modal.Header>IAPT Questionnaire</Modal.Header>
                                            <Modal.Content>
                                                <Form>
                                                    <Tab
                                                        menu={{ secondary: true, pointing: true }}
                                                        panes={iaptModalTabs}
                                                        activeIndex={this.state.iaptModalActiveIndex}
                                                        onTabChange={this.handleTabChange}
                                                    />
                                                </Form>
                                            </Modal.Content>
                                            <Modal.Actions>
                                                <Button type={"button"} content="Submit" onClick={() => this.submitIAPTQuestionnaireModal()} />
                                                <Button type={"button"} content="Close" onClick={() => this.closeQuestionaireModal()} />
                                            </Modal.Actions>
                                        </Modal>
                                        <Label><b>IAPT Section</b></Label>
                                        <br />
                                        <Button type={"button"} onClick={() => this.openIAPTQuestionnaireModal()}>
                                            {iaptMasterConfig.some(m => this.props.questions.some(q => m.id === q.id)) ? "Edit" : "Complete"}
                                        &nbsp;IAPT Questionnaire
                                        </Button>
                                        <br />
                                        <br />
                                        <NumberQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            min={0}
                                            max={27}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingPHQ9Score",
                                                questionText: "PHQ9 Score (These comments will be added to your report)"
                                            })}
                                            questionClassName={"question-red"}
                                            onAnswerChange={(answer) => this.onPsychologicalWellbeingScoreChange(
                                                "PsychologicalWellbeingPHQ9Outcome",
                                                "PHQ9 Outcome",
                                                answer
                                            )}
                                        />
                                        <DropdownQuestion
                                            hideDivider
                                            inline
                                            readonly
                                            questionConfig={({
                                                id: "PsychologicalWellbeingPHQ9Outcome",
                                                questionText: "PHQ9 Outcome"
                                            })}
                                            options={psychologicalAssessmentOutcomeQuestionOptions}
                                        />
                                        <NumberQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            min={0}
                                            max={21}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingGAD7Score",
                                                questionText: "GAD7 Score (These comments will be added to your report)"
                                            })}
                                            questionClassName={"question-red"}
                                            onAnswerChange={(answer) => this.onPsychologicalWellbeingScoreChange(
                                                "PsychologicalWellbeingGAD7Outcome",
                                                "GAD7 Outcome",
                                                answer
                                            )}
                                        />
                                        <DropdownQuestion
                                            hideDivider
                                            inline
                                            readonly
                                            questionConfig={({
                                                id: "PsychologicalWellbeingGAD7Outcome",
                                                questionText: "GAD7 Outcome"
                                            })}
                                            options={psychologicalAssessmentOutcomeQuestionOptions}
                                        />
                                        <NumberQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            min={0}
                                            max={40}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingWSASScore",
                                                questionText: "WSAS Score (These comments will be added to your report)"
                                            })}
                                            questionClassName={"question-red"}
                                            onAnswerChange={(answer) => this.onPsychologicalWellbeingScoreChange(
                                                "PsychologicalWellbeingWSASOutcome",
                                                "WSAS Outcome",
                                                answer
                                            )}
                                        />
                                        <DropdownQuestion
                                            hideDivider
                                            inline
                                            readonly
                                            questionConfig={({
                                                id: "PsychologicalWellbeingWSASOutcome",
                                                questionText: "WSAS Outcome"
                                            })}
                                            options={psychologicalAssessmentOutcomeQuestionOptions}
                                            mandatory
                                        />
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingAdditionalQuestionnaires",
                                                questionText: "Additional Questionnaires"
                                            })}
                                            mandatory
                                        />
                                        <MultiButtonQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingRiskAssessmentCompleted",
                                                questionText: "Risk Assessment Completed"
                                            })}
                                            mandatory
                                        />
                                        {/* eslint-disable-next-line max-len */}
                                        {getAnswerToQuestionWithId(this.props.questions, "PsychologicalWellbeingRiskAssessmentCompleted") === YesOption &&
                                            <>
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingSuicideCurrent",
                                                        questionText: "Suicide: Current (within 2 wks) thoughts / plans / actions"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingSuicideCurrent",
                                                                "Suicide: Current (within 2 wks) thoughts / plans / actions"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingDSHCurrent",
                                                        questionText: "DSH: Current (within 2 wks) thoughts/ plans / actions"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingDSHCurrent",
                                                                "DSH: Current (within 2 wks) thoughts/ plans / actions"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingSuicidePast",
                                                        questionText: "Suicide: Past (More than 2 wks) thoughts/ plans / actions"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingSuicidePast",
                                                                "Suicide: Past (More than 2 wks) thoughts/ plans / actions"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingDSHPast",
                                                        questionText: "DSH: Past (More than 2 wks) thoughts/ plans / actions"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingDSHPast",
                                                                "DSH: Past (More than 2 wks) thoughts/ plans / actions"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingProtectiveFactors",
                                                        questionText: "Protective Factors"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingProtectiveFactors",
                                                                "Protective Factors"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingRiskToSelfOrFromOthers",
                                                        questionText: "Risk to self or from others"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingRiskToSelfOrFromOthers",
                                                                "Risk to self or from others"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingSafeguardingConcerns",
                                                        questionText: "Safeguarding concerns"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingSafeguardingConcerns",
                                                                "Safeguarding concerns"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingSelfNeglect",
                                                        questionText: "Self neglect"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingSelfNeglect",
                                                                "Self neglect"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingSafetyPlan",
                                                        questionText: "Safety plan: Who would this person talk to / give support line numbers"
                                                            + " / emails / advise on crisis support from GP, 111 and A&E"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingSafetyPlan",
                                                                "Safety plan: Who would this person talk to / give support line numbers"
                                                                + " / emails / advise on crisis support from GP, 111 and A&E"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingUseSafetyPlan",
                                                        questionText: "Use safety Plan document if there is a risk - this can be emailed to clients"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingUseSafetyPlan",
                                                                "Use safety Plan document if there is a risk - this can be emailed to clients"
                                                            )}
                                                        />
                                                    }
                                                />
                                                <TextQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "PsychologicalWellbeingTakeGPDetails",
                                                        questionText: "If there are risk concerns take GP details:"
                                                    })}
                                                    multiline
                                                    textSnippetSelector={
                                                        <TextSnippetSelector
                                                            padded
                                                            onSelect={(selectedSnippet) => this.updateSnippets(
                                                                selectedSnippet,
                                                                "PsychologicalAssessment",
                                                                "PsychologicalWellbeingTakeGPDetails",
                                                                "If there are risk concerns take GP details:"
                                                            )}
                                                        />
                                                    }
                                                />
                                            </>
                                        }
                                        <DropdownQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingImpactOnAbilityToPerformJob",
                                                questionText:
                                                    // eslint-disable-next-line max-len
                                                    "What are the perceived stressors in relation to the HSE standards and how are they impacting on them?"
                                            })}
                                            options={impactOnAbilityToPerformJobQuestionOptions}
                                            multiple
                                        />
                                        {chosenImpactsOnAbilityToPerformJobAnswerConfigs.map((impactOnAbility: { text: string; value: string }) =>
                                            (
                                                <>
                                                    <TextQuestion
                                                        hideDivider
                                                        inline
                                                        readonly={this.props.readonly}
                                                        key={impactOnAbility.value}
                                                        questionConfig={({
                                                            id: "PsychologicalWellbeingImpactOnAbilityToPerformJob" + impactOnAbility.value,
                                                            questionText: impactOnAbility.text
                                                        })}
                                                        popupContent={
                                                            <List bulleted>
                                                                <List.Item>Resources</List.Item>
                                                                <List.Item>Techniques from past therapies</List.Item>
                                                            </List>
                                                        }
                                                        multiline
                                                        mandatory
                                                        textSnippetSelector={
                                                            <TextSnippetSelector
                                                                padded
                                                                onSelect={(selectedSnippet) => this.updateSnippets(
                                                                    selectedSnippet,
                                                                    "PsychologicalAssessment",
                                                                    "PsychologicalWellbeingImpactOnAbilityToPerformJob" + impactOnAbility.value,
                                                                    impactOnAbility.text
                                                                )}
                                                            />
                                                        }
                                                    />
                                                </>
                                            )
                                        )}
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingPositiveCopingStrategies",
                                                questionText: "Positive coping strategies:"
                                            })}
                                            popupContent={
                                                <List bulleted>
                                                    <List.Item>Agreed understanding of problem</List.Item>
                                                    <List.Item>Plan for treatment</List.Item>
                                                </List>
                                            }
                                            multiline
                                            textSnippetSelector={
                                                <TextSnippetSelector
                                                    padded
                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                        selectedSnippet,
                                                        "PsychologicalAssessment",
                                                        "PsychologicalWellbeingPositiveCopingStrategies",
                                                        "Positive coping strategies:"
                                                    )}
                                                />
                                            }
                                        />
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychologicalWellbeingAnyOtherRelevantADSMS",
                                                questionText: "Additional Comments or Questionnaires"
                                            })}
                                            multiline
                                            textSnippetSelector={
                                                <TextSnippetSelector
                                                    padded
                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                        selectedSnippet,
                                                        "PsychologicalAssessment",
                                                        "PsychologicalWellbeingAnyOtherRelevantADSMS",
                                                        "Additional Comments or Questionnaires"
                                                    )}
                                                />
                                            }
                                        />
                                    </>
                                }
                                <div className={"fields-divider"} />
                            </AccordionQuestionnaireSection>
                        </>}
                        <AccordionQuestionnaireSection
                            title="Physiotherapy Assessment"
                            key="PhysiotherapyAssessment"
                            id="PhysiotherapyAssessment"
                            index={10}
                        >
                            <MultiButtonQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "CarryOutPhysiotherapyAssessment",
                                    questionText: "Do you wish to carry out a physiotherapy assessment?"
                                })}
                                mandatory
                            />
                            {getAnswerToQuestionWithId(this.props.questions, "CarryOutPhysiotherapyAssessment") === YesOption &&
                                <>
                                    {getAnswerToQuestionWithId(this.props.questions, "PhysiotherapyAssessmentPainNRSAverage") &&
                                        <NumberQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PhysiotherapyAssessmentPainNRSAverage",
                                                questionText: "Pain NRS Average: 0 – No pain – 10 – Excruciating / worst pain ever"
                                            })}
                                            min={0}
                                            max={10}
                                            mandatory
                                        />
                                    }
                                    {useFullAssessment && <>
                                        <NumberQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PhysiotherapyAssessmentPainNRSWorse",
                                                questionText: "Pain NRS Worse: 0 – No pain – 10 – Excruciating / worst pain ever"
                                            })}
                                            min={0}
                                            max={10}
                                            mandatory
                                        />
                                        <NumberQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PhysiotherapyAssessmentPainNRSBest",
                                                questionText: "Pain NRS Best: 0 – No pain – 10 – Excruciating / worst pain ever"
                                            })}
                                            min={0}
                                            max={10}
                                            mandatory
                                        />
                                    </>}
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PhysiotherapyAssessmentTwentyFourHourPattern",
                                            questionText: "24 Hour Pattern"
                                        })}
                                        multiline
                                        textSnippetSelector={
                                            <TextSnippetSelector
                                                padded
                                                onSelect={(selectedSnippet) => this.updateSnippets(
                                                    selectedSnippet,
                                                    "PhysiotherapyAssessment",
                                                    "PhysiotherapyAssessmentTwentyFourHourPattern",
                                                    "24 Hour Pattern"
                                                )}
                                            />
                                        }
                                    />
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PhysiotherapyAssessmentAggravatingEasingFactors",
                                            questionText: "Aggravating / Easing Factors"
                                        })}
                                        multiline
                                        textSnippetSelector={
                                            <TextSnippetSelector
                                                padded
                                                onSelect={(selectedSnippet) => this.updateSnippets(
                                                    selectedSnippet,
                                                    "PhysiotherapyAssessment",
                                                    "PhysiotherapyAssessmentAggravatingEasingFactors",
                                                    "Aggravating / Easing Factors"
                                                )}
                                            />
                                        }
                                    />
                                    <MultiButtonQuestion
                                        inline
                                        hideDivider
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PhysiotherapyAssessmentCompleteCervicalSpineSpecialQuestions",
                                            questionText: "Complete Cervical Spine Special Questions"
                                        })}
                                        mandatory
                                    />
                                    {getAnswerToQuestionWithId(
                                        this.props.questions,
                                        "PhysiotherapyAssessmentCompleteCervicalSpineSpecialQuestions") === YesOption &&
                                        <>
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalConstantHeadache",
                                                    questionText: "1. Constant Headache"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentNausea",
                                                    questionText: "2. Nausea"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalSensoryChanges",
                                                    questionText: "3. Sensory changes: Pins and needles / numbness"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalDropAttacks",
                                                    questionText: "4. Drop attacks"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalDizziness",
                                                    questionText: "5. Dizziness"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalSwallowingDifficulties",
                                                    questionText: "6. Swallowing difficulties"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalSpeechDifficulties",
                                                    questionText: "7. Speech difficulties"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalVisionDifficulties",
                                                    questionText: "8. Vision difficulties / double vision"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalAlteredGait",
                                                    questionText: "9. Altered gait"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalConstantNightPain",
                                                    questionText: "10. Constant Night pain"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalUnexplainedWeightLoss",
                                                    questionText: "11. Unexplained weight loss"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                hideDivider
                                                inline
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentCervicalPreviousHistoryOfCancer",
                                                    questionText: "12. Previous history of Cancer"
                                                })}
                                                mandatory
                                            />
                                        </>
                                    }
                                    <MultiButtonQuestion
                                        inline
                                        hideDivider
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PhysiotherapyAssessmentCompleteLumbarSpineSpecialQuestions",
                                            questionText: "Complete Lumbar spine special questions"
                                        })}
                                        mandatory
                                    />
                                    {getAnswerToQuestionWithId(this.props.questions, "PhysiotherapyAssessmentCompleteLumbarSpineSpecialQuestions")
                                        === YesOption &&
                                        <>
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentLumbarBowelOrBladderSymptoms",
                                                    questionText: "1. Bowel or Bladder symptoms"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentLumbarSaddleAnaesthesia",
                                                    questionText: "2. Saddle anaesthesia"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentLumbarBilateralLegPainPinsAndNeedles",
                                                    questionText: "3. Bi-lateral leg pain / Pins and needles"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentLumbarAlteredGait",
                                                    questionText: "4. Altered Gait"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentLumbarConstantNightPain",
                                                    questionText: "5. Constant night pain"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentLumbarUnexplainedWeightLoss",
                                                    questionText: "6. Unexplained weight loss"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentLumbarPreviousHistoryOfCancer",
                                                    questionText: "7. Previous history of Cancer"
                                                })}
                                                mandatory
                                            />
                                        </>
                                    }
                                    <MultiButtonQuestion
                                        inline
                                        hideDivider
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PhysiotherapyAssessmentCompletePeripheralJointSpecialQuestions",
                                            questionText: "Complete Peripheral Joint special questions"
                                        })}
                                        mandatory
                                    />
                                    {getAnswerToQuestionWithId(
                                        this.props.questions,
                                        "PhysiotherapyAssessmentCompletePeripheralJointSpecialQuestions") === YesOption &&
                                        <>
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentJointSevereSwelling",
                                                    questionText: "1. Severe swelling"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentJointPoppingClicking",
                                                    questionText: "2. Popping / Clicking"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentJointGivingWayInstability",
                                                    questionText: "3. Giving way / instability"
                                                })}
                                                mandatory
                                            />
                                            <MultiButtonQuestion
                                                inline
                                                hideDivider
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "PhysiotherapyAssessmentJointLockingCatching",
                                                    questionText: "4. Locking / catching"
                                                })}
                                                mandatory
                                            />
                                        </>
                                    }
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PhysiotherapyAssessmentObjectiveAssessment",
                                            questionText: "Objective Assessment"
                                        })}
                                        multiline
                                        textSnippetSelector={
                                            <TextSnippetSelector
                                                padded
                                                onSelect={(selectedSnippet) => this.updateSnippets(
                                                    selectedSnippet,
                                                    "PhysiotherapyAssessment",
                                                    "PhysiotherapyAssessmentObjectiveAssessment",
                                                    "Objective Assessment"
                                                )}
                                            />
                                        }
                                    />
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PhysiotherapyAssessmentClinicalImpression",
                                            questionText: "Clinical Impression"
                                        })}
                                        multiline
                                        textSnippetSelector={
                                            <TextSnippetSelector
                                                padded
                                                onSelect={(selectedSnippet) => this.updateSnippets(
                                                    selectedSnippet,
                                                    "PhysiotherapyAssessment",
                                                    "PhysiotherapyAssessmentClinicalImpression",
                                                    "Clinical Impression"
                                                )}
                                            />
                                        }
                                    />
                                    {useFullAssessment && <>
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PhysiotherapyAssessmentClientsExpectations",
                                                questionText: "Clients Expectations"
                                            })}
                                            multiline
                                            textSnippetSelector={
                                                <TextSnippetSelector
                                                    padded
                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                        selectedSnippet,
                                                        "PhysiotherapyAssessment",
                                                        "PhysiotherapyAssessmentClientsExpectations",
                                                        "Clients Expectations"
                                                    )}
                                                />
                                            }
                                        />
                                        <DropdownQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PhysiotherapyAssessmentAdherenceToHomeExerciseAndAdvicePlan",
                                                questionText: "Adherence to Home Exercise and Advice Plan"
                                            })}
                                            options={adherenceToHomeExerciseAndAdvicePlanQuestionOptions}
                                            mandatory
                                        />
                                    </>}
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PhysiotherapyAssessmentDetailsOfSelfManagement",
                                            questionText: "Details of self-management advice and exercise plan"
                                        })}
                                        multiline
                                        textSnippetSelector={
                                            <TextSnippetSelector
                                                padded
                                                onSelect={(selectedSnippet) => this.updateSnippets(
                                                    selectedSnippet,
                                                    "PhysiotherapyAssessment",
                                                    "PhysiotherapyAssessmentDetailsOfSelfManagement",
                                                    "Details of self-management advice and exercise plan"
                                                )}
                                            />
                                        }
                                    />
                                </>
                            }
                        </AccordionQuestionnaireSection>
                        {useFullAssessment &&
                            <AccordionQuestionnaireSection
                                title="Psychosocial / Barriers to Work"
                                key="PsychosocialBarriersToWork"
                                id="PsychosocialBarriersToWork"
                                index={11}
                            >
                                {this.warningTextHeader()}
                                <MultiButtonQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "CarryOutPsychosocialBarriersToWork",
                                        questionText: "Are there any psychosocial barriers to returning to work? (these comments will be added to "
                                            + "your report)"
                                    })}
                                    questionClassName={"question-red"}
                                    mandatory
                                />
                                {getAnswerToQuestionWithId(this.props.questions, "CarryOutPsychosocialBarriersToWork") === YesOption &&
                                    <>
                                        <p className="clinical-notes-header additional-padding">Psychosocial barriers to Returning from Work</p>
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychosocialBarriersToWorkUnhelpfulBeliefs",
                                                questionText: "Unhelpful Beliefs"
                                            })}
                                            mandatory
                                        />
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychosocialBarriersToWorkPoorPerceptionOfWork",
                                                questionText: "Poor perception of work"
                                            })}
                                            mandatory
                                        />
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychosocialBarriersToWorkLegalActionClaim",
                                                questionText: "Legal Action / Claim"
                                            })}
                                            mandatory
                                        />
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychosocialBarriersToWorkFinances",
                                                questionText: "Finances"
                                            })}
                                            mandatory
                                        />
                                        <MultiButtonQuestion
                                            inline
                                            hideDivider
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychosocialBarriersToWorkFamilyFactors",
                                                questionText: "Family Factors"
                                            })}
                                            mandatory
                                        />
                                        <MultiButtonQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychosocialBarriersToWorkMentalEmotionalFactors",
                                                questionText: "Mental / Emotional Factors"
                                            })}
                                            mandatory
                                        />
                                        <TextQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "PsychosocialBarriersDetails",
                                                questionText: "Details (These comments will be added to your report)"
                                            })}
                                            questionClassName={"question-red"}
                                            multiline
                                            textSnippetSelector={
                                                <TextSnippetSelector
                                                    padded
                                                    onSelect={(selectedSnippet) => this.updateSnippets(
                                                        selectedSnippet,
                                                        "PsychosocialBarriersToWork",
                                                        "PsychosocialBarriersDetails",
                                                        "Details (These comments will be added to your report)"
                                                    )}
                                                />
                                            }
                                        />
                                    </>
                                }
                                <div className={"fields-divider"} />
                            </AccordionQuestionnaireSection>
                        }
                    </>
                )
            }
            {this.props.customer.useToyotaTemplates && <>
                <AccordionQuestionnaireSection
                    title="Medical Certificate Issued"
                    key="MedicalCertificateIssued"
                    id="MedicalCertificateIssued"
                    index={12}
                >
                    <MultiButtonQuestion
                        hideDivider
                        inline
                        readonly={this.props.readonly}
                        questionConfig={({
                            id: "MedicalCertificateIssued",
                            questionText: "Medical Certificate Issued?"
                        })}
                        mandatory
                    />
                    {getAnswerToQuestionWithId(this.props.questions, "MedicalCertificateIssued") === YesOption &&
                        <>
                            <OldDateQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "AbsenceMedicalCertificateDate",
                                    questionText: "Please select first date of absence on medical certificate"
                                })}
                                mandatory
                            />
                            <OldDateQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "LastDateOfAbsenceMedicalCertificate",
                                    questionText: "Enter the last date of absence according to the medical certificate\n"
                                })}
                                mandatory
                            />
                        </>
                    }
                </AccordionQuestionnaireSection>
            </>}
            <>
                <AccordionQuestionnaireSection
                    title="Medical Classification"
                    key="MedicalClassification"
                    id="MedicalClassification"
                    index={13}
                >
                    {this.warningTextHeader()}
                    <DropdownQuestion
                        hideDivider
                        inline
                        readonly={this.props.readonly}
                        questionConfig={({ id: "MedicalClassification", questionText: "Medical Classification" })}
                        questionClassName={this.getQuestionClassName()}
                        filterOldOptions
                        options={ohaMedicalClassificationOptions}
                        mandatory
                    />
                    {medicalClassificationSubCategoryOptions[getAnswerToQuestionWithId(this.props.questions, "MedicalClassification") as string]
                        &&
                        <>
                            <DropdownQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({ id: "MedicalClassificationSubCategory", questionText: "Sub Category" })}
                                questionClassName={this.getQuestionClassName()}
                                filterOldOptions
                                options={medicalClassificationSubCategoryOptions[getAnswerToQuestionWithId(
                                    this.props.questions,
                                    "MedicalClassification") as string] ?? []}
                                mandatory
                            />
                        </>
                    }
                    <DropdownQuestion
                        hideDivider
                        inline
                        readonly={this.props.readonly}
                        questionConfig={({
                            id: "MedicalClassificationWorkRelatedHealthIssue",
                            questionText: "Work Related Health Issue"
                        })}
                        options={workRelatedHealthIssueQuestionOptions}
                        mandatory
                    />
                </AccordionQuestionnaireSection>
            </>
            <OutcomeAndOnwardManagementOfTheCaseSection
                questionnaireKey={questionnaireKey}
                questions={this.props.questions}
                readonly={this.props.readonly}
                useToyotaTemplates={this.props.customer.useToyotaTemplates ?? false}
                useSimplifiedNotesAndReport={useSimplifiedNotesAndReport}
                isDateInTheFuture={isDateInTheFuture}
                isDateInThePast={isDateInThePast}
                getQuestionClassName={this.getQuestionClassName}
                warningTextHeader={this.warningTextHeader}
                updateSnippets={this.updateSnippets}
                updateAnswer={this.props.updateAnswer} />
            <>
                <AccordionQuestionnaireSection
                    title="Consent to Release the Report"
                    key={"Completion"}
                    id={"Completion"}
                    index={15}
                    hideNextButton
                >
                    <p>Please clearly outline the content of your report to the employee and then ask them confirm their preference for consent</p>
                    <p><strong>Note:</strong> Once your report has been written it will be managed based on the choice that you make below</p>
                    <RadioButtonQuestion
                        hideDivider={!!getAnswerToQuestionWithId(this.props.questions, "ScopeOfReport")}
                        inline
                        readonly={this.props.readonly}
                        questionConfig={({ id: "ScopeOfReport", questionText: "Consent for release of Report" })}
                        mandatory
                    >
                        <RadioButton
                            label="I would like to see a copy of my report before it is released to HR and my Manager"
                            value="CopyRequired"
                        />
                        <RadioButton
                            label="I am happy for the report to be sent to me, HR and my Manager at the same time"
                            value="CopyRequiredSameTime"
                        />
                        <RadioButton
                            // eslint-disable-next-line max-len
                            label="Neither of the above (choose this option if any of the email addresses below are wrong or if the employee / manager email address is blank)"
                            value="AlternativeScope"
                        />
                    </RadioButtonQuestion>
                    {
                        (() => {
                            switch (getAnswerToQuestionWithId(this.props.questions, "ScopeOfReport")) {
                                case "CopyRequired":
                                    // eslint-disable-next-line max-len
                                    return <Segment>If the employee chooses to see the report first you must notify them that the report will be sent to the Optima Health portal and they will receive an email notification telling them that the report is ready. Advise them that they <strong>must</strong> respond to this within 5 Days or the report will be automatically sent to their Manager and HR. <strong>Check the email address of the manager and employee are correct below. If not, or the employee / manager email address is blank you must select the third option (Neither of the above)</strong></Segment>;
                                case "CopyRequiredSameTime":
                                    // eslint-disable-next-line max-len
                                    return <Segment>Advise the employee that they will receive a copy of the report via the Optima Health portal and that they will receive an email notification telling them the report is ready. <strong>Check the email address of the manager and employee are correct below. If not, or the employee / manager email address is blank you must select the third option (Neither of the above)</strong></Segment>;
                                case "AlternativeScope":
                                    return (<TextQuestion
                                        inline
                                        mandatory
                                        readonly={this.props.readonly}
                                        questionConfig={({ id: "AlternativeConsentChoice", questionText: "Details of Alternative Consent choice" })}
                                        multiline
                                    />);
                                default:
                                    return null;
                            }
                        })()
                    }
                    <TextQuestion
                        inline
                        readonly
                        questionConfig={({ id: "EmployeeEmailAddress", questionText: "Employee Email Address" })}
                        answer={this.props.ohCase?.personalEmailAddress}
                    />
                    <TextQuestion
                        inline
                        readonly
                        questionConfig={({ id: "ManagerEmailAddress", questionText: "Manager Email Address" })}
                        answer={this.props.consultationDetails && this.props.consultationDetails.lineManagersEmails.join(" & ")}
                    />
                    {this.props.consultationDetails && this.props.consultationDetails.hrEmails &&
                        <TextQuestion
                            inline
                            readonly
                            questionConfig={({ id: "HREmailAddress", questionText: "HR Email Address" })}
                            answer={this.props.consultationDetails && this.props.consultationDetails.hrEmails.join(" & ")}
                        />
                    }
                </AccordionQuestionnaireSection>
            </>
        </>);

        return (
            <Container className="clinical-notes">
                <h2 className={this.props.readonly ? "" : "sticky-header"}>
                    Clinical Notes for {this.props.ohCase && `${this.props.ohCase.employeeFirstName} ${this.props.ohCase.employeeLastName}`}
                </h2>
                {this.props.readonly ? null :
                    <>
                        <p>
                            I am an Occupational Health Advisor with Optima Health working on behalf of your employer. I am calling as your manager has referred
                            you to Occupational Health in order to determine how best to support you. My role is to assess your current health situation and to
                            provide advice to you and your manager. Is it convenient to talk?
                        </p>
                        <Container textAlign="right" className="start-button">
                            {!this.props.customer.useToyotaTemplates && <PhysioAssessmentFormVersionButton
                                ohCaseId={this.props.ohCaseId}
                                taskId={this.props.taskId}
                                currentFormVersion={physioAssessmentFormVersionQuestionAnswer}
                                onConsultationFormChange={this.onConsultationFormChange}
                            />}
                            <ViewClinicalHistoryButton
                                customerId={this.props.customerId}
                                employeeRecordId={this.props.ohCase.employeeRecordId!}
                            />
                            <PreviewReferralReportButton
                                customerId={this.props.customerId}
                                employeeRecordId={this.props.ohCase.employeeRecordId!}
                                ohCaseId={this.props.ohCaseId}
                                taskId={this.props.taskId}
                            />
                            <DidNotAttendButton
                                customerId={this.props.customerId}
                                ohCaseId={this.props.ohCaseId}
                                task={this.props.task}
                            />
                            <Button onClick={() => this.props.startNotes()} content="Start Notes" />
                        </Container>
                    </>}
                <AccordionQuestionnaireContainer
                    autoSaveQuestionnaire={
                        this.state.redirectChecked && !this.state.redirecting && !this.props.readonly && !this.state.submitted
                            ? this.saveQuestionnaire
                            : undefined
                    }
                    loadQuestionnaire={this.loadQuestionnaire as ((abortController?: AbortController) => any)}
                    submitQuestionnaire={this.submitQuestionnaire}
                    readonly={this.props.readonly}
                    questionnaireKey={questionnaireKey}
                    otherActionButtons={this.props.readonly ? null : (
                        <a
                            href={`/customers/${this.props.customerId}/employeeRecords/${this.props.ohCase.employeeRecordId}`
                                + `/ohCases/${this.props.ohCaseId}/${this.props.taskId}/previewReport`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button type="button" content="Preview Report" />
                        </a>
                    )}
                    questionnaireType={QuestionnaireTypes.ClinicalNotes}
                    task={this.props.task}
                    removeAppointment={() => new TasksApi().removeAppointment(this.props.task.caseId, this.props.task.id)}
                >
                    {questionnaireContainerContent}
                </AccordionQuestionnaireContainer>
            </Container>
        );
    }
}

const mapStateToProps = (
    state: ApplicationState & EmployeeRecordState & ActionableTasksState
): ClinicalNotesStateProps => {
    const taskId = state.router.params && state.router.params.taskId;
    let task = state.actionableTasks.tasks.find(t => t.id === taskId);
    const ohCaseId = ohCaseIdSelector(state) || (task && task.caseId);
    const ohCase = state.ohCases.find(c => c.id === ohCaseId) as OhCaseListModel | OhCaseDetailModel;
    let employeeRecord;
    let isLoading = true;
    if (ohCase && "tasks" in ohCase && ohCase.tasks) {
        task = task || ohCase.tasks.find(t => t.id === taskId);
        employeeRecord = state.employeeRecordsDetail.employeeRecords.find(e => e.id === ohCase.employeeRecordId) as EmployeeRecord;
        if (state.currentUser) {
            isLoading = false;
        }
    }
    const adminUsers = adminUsersSelector(state);
    return {
        customerId: state.router.params?.customerId || task?.customer.id,
        customer: customerSelector(state),
        consultationDetails: state.consultationDetails.find(r => r.consultationTaskId === taskId),
        ohCaseId,
        taskId,
        task,
        isOhp: ohpTaskTypes.some(t => t === task?.typeId) || false,
        currentUser: state.currentUser,
        ohCase,
        questions: state.questionnaires[questionnaireKey] ?
            uniq(flatten(state.questionnaires[questionnaireKey].sections.map(section => values(section.questions)))) :
            [],
        readonly: (!task || task?.completed || task?.cancelled),
        isLoading,
        employeeRecord,
        adminUsers,
        clinicansQualification: adminUsers.find(u => u.id === state.currentUser.id)?.qualification,
        eTag: state.questionnaires[questionnaireKey]?.eTag
    };
};

const mapDispatchToProps = (dispatch: any): ClinicalNotesDispatchProps => {
    return {
        navigateToOldClinicalNotes: (customerId: string, employeeRecordId: string, ohCaseId: string, taskId: string, version: number) =>
            dispatch(replace(`/customers/${customerId}/employeeRecords/${employeeRecordId}/ohCases/${ohCaseId}/${taskId}/oldReferralClinicalNotes/${version}`)),
        startNotes: () => dispatch(openSection({ sectionId: "CompletedOnBehalfOf", questionnaireKey })),
        loadQuestionnaire: (abortController: AbortController, ohCaseId: string, taskId: string) =>
            dispatch(loadQuestionnaire(abortController, ohCaseId, taskId, questionnaireKey)),
        loadConsultationDetails: (ohCaseId: string, taskId: string) => dispatch(loadConsultationDetails({ ohCaseId, taskId })),
        updateAnswer: payload => dispatch(updateQuestion({ ...payload, questionnaireKey })),
        submitDidNotAttend: (ohCaseId: string, taskId: string, comment: string | undefined) =>
            dispatch(submitDidNotAttend(ohCaseId, taskId, comment ?? "")),
        loadEmployee: (employeeRecordId: string, customerId: string) => dispatch(loadEmployeeRecordDetail({ employeeRecordId, customerId })),
        onCompletion: () => dispatch(navigateToParentRoute()),
        submitInvalidQuestionnaire: () => dispatch(submitInvalidQuestionnaire(questionnaireKey)),
        loadAdminUsers: () => dispatch(loadAdminUsers()),
        clearQuestionnaire: () => dispatch(clearQuestionnaire(questionnaireKey)),
        removeAnswer: payload => dispatch(removeQuestion({ ...payload, questionnaireKey })),
    };
};

const mergeProps = (stateProps: ClinicalNotesStateProps, dispatchProps: ClinicalNotesDispatchProps, ownProps: ClinicalNotesOwnProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps
});

export const ReferralClinicalNotesSections = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ReferralClinicalNotesSectionsUnconnected);
